{
 "@catalog/Build": "Строить",
 "@catalog/Build/Windows and Doors": "Окна и двери",
 "@catalog/Build/Windows and Doors/Doors": "Двери",
 "@catalog/Build/Windows and Doors/Doors#Single Doors": "Одиночные двери",
 "@catalog/Build/Windows and Doors/Doors#Double Doors": "Двойные двери",
 "@catalog/Build/Windows and Doors/Doors#Arch Doors": "Арочные двери",
 "@catalog/Build/Windows and Doors/Doors#Entry Doors": "Входные двери",
 "@catalog/Build/Windows and Doors/Doors#Entrance set": "Входной набор",
 "@catalog/Build/Windows and Doors/Doors#Sliding Doors": "Раздвижные двери",
 "@catalog/Build/Windows and Doors/Doors#Folding Doors": "Складные двери",
 "@catalog/Build/Windows and Doors/Doors#Balcony Doors": "Балконные двери",
 "@catalog/Build/Windows and Doors/Doors#Special Doors": "Специальные двери",
 "@catalog/Build/Windows and Doors/Windows": "Окна",
 "@catalog/Build/Windows and Doors/Arches": "Арки",
 "@catalog/Build/Windows and Doors/CeilingCurtains": "Потолочные шторы",
 "@catalog/Build/Windows and Doors/Curtains": "Шторы",
 "@catalog/Build/Windows and Doors/Openings": "Проёмы",
 "@catalog/Build/Windows and Doors/Garage Doors": "Гаражные ворота",
 "@catalog/Build/Windows and Doors/Skylight": "Мансардное окно",
 "@catalog/Build/Windows and Doors/Shutters": "Ставни",
 "@catalog/Build/Windows and Doors/Window sills": "Подоконники",
 "@catalog/Build/Windows and Doors/Elevator": "Лифт",
 "@catalog/Build/Constructions": "Конструкции",
 "@catalog/Build/Constructions/Primitives": "Примитивы",
 "@catalog/Build/Constructions/Interior Wall": "Стена",
 "@catalog/Build/Constructions/CeilingDecor": "Потолочные конструкции",
 "@catalog/Build/Constructions/Wall constructions": "Стеновые конструкции",
 "@catalog/Build/Constructions/Moldings": "Молдинги",
 "@catalog/Build/Constructions/Columns": "Колонны",
 "@catalog/Build/Constructions/Stucco": "Лепнина",
 "@catalog/Build/Constructions/Pipes": "Трубы",
 "@catalog/Build/Materials": "Материалы",
 "@catalog/Build/Materials/Other": "Другой",
 "@catalog/Build/Materials/Wood": "Дерево",
 "@catalog/Build/Materials/Marble": "Мрамор",
 "@catalog/Build/Materials/Tile": "Плитка",
 "@catalog/Build/Materials/Slats": "Ламели",
 "@catalog/Build/Materials/Fabric": "Ткань",
 "@catalog/Build/Materials/Wallpapers": "Обои",
 "@catalog/Build/Materials/Finishes": "Отделка",
 "@catalog/Build/Materials/Paneling": "Панели",
 "@catalog/Build/Materials/Parquet or Laminate": "Паркет, ламинат",
 "@catalog/Build/Materials/Glass": "Стекло",
 "@catalog/Build/Materials/Stone": "Камень",
 "@catalog/Build/Materials/Bricks": "Кирпичи",
 "@catalog/Build/Materials/Carpet": "Ковролин",
 "@catalog/Build/Materials/MaterialPlants": "Растения",
 "@catalog/Build/Materials/Metal": "Металл",
 "@catalog/Build/Materials/Photo Wallpaper": "Фотообои",
 "@catalog/Build/Materials/Ground": "Земля",
 "@catalog/Build/Materials/Granite": "Гранит",
 "@catalog/Build/Materials/Neon": "Неон",
 "@catalog/Build/Materials/Water": "Вода",
 "@catalog/Build/Materials/Sky": "Небо",
 "@catalog/Build/Materials/Rattan": "Ротанг",
 "@catalog/Build/Materials/Leather": "Кожа",
 "@catalog/Build/Materials/Roof": "Крыша",
 "@catalog/Build/Materials/Colors": "Цвета",
 "@catalog/Build/Stairs": "Лестница",
 "@catalog/Build/Stairs#Steps": "Ступени",
 "@catalog/Build/Stairs#Straight Stairs": "Прямая лестница",
 "@catalog/Build/Stairs#L-shape Stairs": "Г-образная лестница",
 "@catalog/Build/Stairs#U-shape Stairs": "П-образная лестница",
 "@catalog/Build/Stairs#Spiral Stairs": "Винтовая лестница",
 "@catalog/Build/Stairs#Curved Stairs": "Изогнутая лестница",
 "@catalog/Build/Stairs#Winder Stairs": "Забежная лестница",
 "@catalog/Build/Stairs#Grand Staircase": "Парадная лестница",
 "@catalog/Build/Stairs#Ladder": "Ladder",
 "@catalog/Build/Stairs#Task Stairs": "Специальная лестница",
 "@catalog/Build/Stairs#Railing": "Перила",
 "@catalog/Build/Climate electronics": "Климатическая электроника",
 "@catalog/Build/Climate electronics/Conditioner": "Кондиционер",
 "@catalog/Build/Climate electronics/Ceiling fan": "Потолочный вентилятор",
 "@catalog/Build/Climate electronics/Heating": "Отопление",
 "@catalog/Build/Climate electronics/Ventilation": "Вентиляция",
 "@catalog/Build/Climate electronics/Fan": "Вентилятор",
 "@catalog/Build/Climate electronics/Air purifier": "Очиститель воздуха",
 "@catalog/Build/Climate electronics/Water heater": "Бойлер",
 "@catalog/Build/Climate electronics/Thermometer": "Термометр",
 "@catalog/Build/Electricity": "Электричество",
 "@catalog/Build/Electricity/LightingOutletsSwitches": "Розетки, выключатели",
 "@catalog/Build/Electricity/Electricity supplies": "Электроприборы",
 "@catalog/Build/Fireplaces": "Камин",
 "@catalog/Build/Fireplaces#Traditional Fireplace": "Traditional Fireplace",
 "@catalog/Build/Fireplaces#Modern Fireplace": "Modern Fireplace",
 "@catalog/Build/Fireplaces#Stove Fireplace": "Stove Fireplace",
 "@catalog/Build/Fireplaces#Freestanding Fireplace": "Отдельностоящий камин",
 "@catalog/Build/Fireplaces#Suspended Fireplace": "Подвесной камин",
 "@catalog/Build/Fireplaces#Fireplace Accessories": "Каминные аксессуары",
 "@catalog/Build/Roofs": "Крыши",
 "@catalog/Build/Roofs/Roof types": "Типы крыш",
 "@catalog/Build/Roofs/Dormer window": "Чердачное окно",
 "@catalog/Build/Roofs/Chimney": "Дымоход",
 "@catalog/Build/Roofs/Gutter": "Ливневка",
 "@catalog/Build/Knobs,handles": "Ручки",
 "@catalog/Other Rooms": "По типу комнаты",
 "@catalog/Other Rooms/kids": "Детская",
 "@catalog/Other Rooms/kids/KidBed": "Детская кровать",
 "@catalog/Other Rooms/kids/Kids Storage": "Детские шкафы",
 "@catalog/Other Rooms/kids/Baby Gear": "Вещи для малышей",
 "@catalog/Other Rooms/kids/Baby Gear/Kids Decor": "Детский декор",
 "@catalog/Other Rooms/kids/Baby Gear/Kids Decor/Toys": "Игрушки",
 "@catalog/Other Rooms/kids/Baby Gear/Kids Decor/KidsDecor": "Детский декор",
 "@catalog/Other Rooms/kids/Baby Gear/Kids Decor/Kids Art": "Детские картины",
 "@catalog/Other Rooms/kids/Baby Gear/Kids Decor/Kids Rugs": "Детские коврики",
 "@catalog/Other Rooms/kids/Baby Gear/Kids Decor/Play Tents": "Игровые палатки",
 "@catalog/Other Rooms/kids/Baby Gear/Crib": "Кроватка",
 "@catalog/Other Rooms/kids/Baby Gear/Kid Lamp": "Детский светильник",
 "@catalog/Other Rooms/kids/Baby Gear/Bed Canopy": "Балдахин",
 "@catalog/Other Rooms/kids/Baby Gear/High Chair": "Высокий стул",
 "@catalog/Other Rooms/kids/Baby Gear/Play Tents": "Игровые палатки",
 "@catalog/Other Rooms/kids/Baby Gear/Changing Table": "Пеленальный стол",
 "@catalog/Other Rooms/kids/Kid Lamp": "Детский светильник",
 "@catalog/Other Rooms/kids/Kids tables and chairs": "Детские столы и стулья",
 "@catalog/Other Rooms/Laundry and cleaning": "Стирка и уборка",
 "@catalog/Other Rooms/Laundry and cleaning/Washers / Dryers": "Стир.машины",
 "@catalog/Other Rooms/Laundry and cleaning/Laundry accessories": "Все для стирки",
 "@catalog/Other Rooms/Laundry and cleaning/Vacuum cleaners and mops": "Пылесосы и швабры",
 "@catalog/Other Rooms/Laundry and cleaning/Cleaning": "Уборка",
 "@catalog/Other Rooms/Laundry and cleaning/Irons and Steamers": "Утюги и отпариватели",
 "@catalog/Other Rooms/Fireplaces": "Камин",
 "@catalog/Other Rooms/bathroom": "Ванная",
 "@catalog/Other Rooms/bathroom/Bath and Spa": "Ванна и спа",
 "@catalog/Other Rooms/bathroom/Bath and Spa/Shower": "Душ",
 "@catalog/Other Rooms/bathroom/Bath and Spa/Shower#Shower Cabin": "Shower Cabin",
 "@catalog/Other Rooms/bathroom/Bath and Spa/Shower#Shower System": "Shower System",
 "@catalog/Other Rooms/bathroom/Bath and Spa/Shower#ShowerMixer": "ShowerMixer",
 "@catalog/Other Rooms/bathroom/Bath and Spa/Shower#ShowerScreen": "ShowerScreen",
 "@catalog/Other Rooms/bathroom/Bath and Spa/Shower#ShowerTray": "ShowerTray",
 "@catalog/Other Rooms/bathroom/Bath and Spa/Bath": "Ванна",
 "@catalog/Other Rooms/bathroom/Bath and Spa/Bath#SingleBath": "SingleBath",
 "@catalog/Other Rooms/bathroom/Bath and Spa/Bath#Bath Faucet": "Bath Faucet",
 "@catalog/Other Rooms/bathroom/Bath and Spa/Bath#Jacuzzi": "Jacuzzi",
 "@catalog/Other Rooms/bathroom/Bath and Spa/Spa": "Спа",
 "@catalog/Other Rooms/bathroom/Bath and Spa/Sauna": "Сауна",
 "@catalog/Other Rooms/bathroom/Bath Accessories": "Аксессуары",
 "@catalog/Other Rooms/bathroom/Bath Accessories/Towel rack": "Вешалка для полотенца",
 "@catalog/Other Rooms/bathroom/Bath Accessories/Bathroom Decor": "Декор ванной",
 "@catalog/Other Rooms/bathroom/Bath Accessories/Soap and shampoo": "Мыло и шампунь",
 "@catalog/Other Rooms/bathroom/Bath Accessories/Toilet Paper Holder": "Держатель туалетной бумаги",
 "@catalog/Other Rooms/bathroom/Bath Accessories/Cosmetics": "Косметика",
 "@catalog/Other Rooms/bathroom/Bath Accessories/Toilet Brush": "Щетка для унитаза",
 "@catalog/Other Rooms/bathroom/Bath Accessories/Toothbrush holder": "Держатель щеток",
 "@catalog/Other Rooms/bathroom/Bath Accessories/Safety rack": "Защитный поручень",
 "@catalog/Other Rooms/bathroom/Bath Accessories/Toilet Seat": "Сиденье для унитаза",
 "@catalog/Other Rooms/bathroom/Bath Accessories/Hair Dryers": "Hair Dryers",
 "@catalog/Other Rooms/bathroom/Bath Accessories/Hand Dryers": "Hand Dryers",
 "@catalog/Other Rooms/bathroom/Lavatory pan": "Унитаз",
 "@catalog/Other Rooms/bathroom/Lavatory pan#Toilet": "Toilet",
 "@catalog/Other Rooms/bathroom/Lavatory pan#Wall-mounted Toilet": "Wall-mounted Toilet",
 "@catalog/Other Rooms/bathroom/Lavatory pan#Flush": "Слив",
 "@catalog/Other Rooms/bathroom/Lavatory pan#Urinal": "Urinal",
 "@catalog/Other Rooms/bathroom/Lavatory pan#Bidet": "Bidet",
 "@catalog/Other Rooms/bathroom/Lavatory pan#Floor Toilet": "Напольный туалет",
 "@catalog/Other Rooms/bathroom/Lavatory pan#Kid Toilet": "Детский туалет",
 "@catalog/Other Rooms/outdoor": "Двор или терраса",
 "@catalog/Other Rooms/outdoor/Swimming pool": "Бассейн",
 "@catalog/Other Rooms/outdoor/Swimming pool/Swimming pool": "Бассейн",
 "@catalog/Other Rooms/outdoor/Swimming pool/Sunbed": "Шезлонг",
 "@catalog/Other Rooms/outdoor/Swimming pool/Umbrella": "Зонтик",
 "@catalog/Other Rooms/outdoor/Swimming pool/Pool Accessories": "Аксессуары для бассейна",
 "@catalog/Other Rooms/outdoor/Garden Structures": "Беседки и заборы",
 "@catalog/Other Rooms/outdoor/Garden Structures/Fences": "Заборы",
 "@catalog/Other Rooms/outdoor/Garden Structures/Fences#Fence": "Забор",
 "@catalog/Other Rooms/outdoor/Garden Structures/Fences#Gate": "Gate",
 "@catalog/Other Rooms/outdoor/Garden Structures/Balcony": "Балкон",
 "@catalog/Other Rooms/outdoor/Garden Structures/Umbrella": "Зонтик",
 "@catalog/Other Rooms/outdoor/Garden Structures/Gazebo": "Беседка",
 "@catalog/Other Rooms/outdoor/Garden Structures/Canopies": "Навесы",
 "@catalog/Other Rooms/outdoor/Garden Structures/Porch": "Крыльцо",
 "@catalog/Other Rooms/outdoor/Garden Structures/Sunhouse": "Теплица",
 "@catalog/Other Rooms/outdoor/Landscaping": "Ландшафтный дизайн",
 "@catalog/Other Rooms/outdoor/Landscaping/Flowers": "Цветы",
 "@catalog/Other Rooms/outdoor/Landscaping/Phytowall": "Фитостена",
 "@catalog/Other Rooms/outdoor/Landscaping/Outdoor plants": "Уличные растения",
 "@catalog/Other Rooms/outdoor/Landscaping/Trees": "Деревья",
 "@catalog/Other Rooms/outdoor/Landscaping/Bushes": "Кусты",
 "@catalog/Other Rooms/outdoor/Landscaping/Roads": "Дороги",
 "@catalog/Other Rooms/outdoor/Landscaping/Roads#Road": "Road",
 "@catalog/Other Rooms/outdoor/Landscaping/Roads#Drain": "Ливневка",
 "@catalog/Other Rooms/outdoor/Landscaping/Roads#Luke": "Люк",
 "@catalog/Other Rooms/outdoor/Landscaping/Fountain": "Фонтан",
 "@catalog/Other Rooms/outdoor/Landscaping/Stones": "Камни",
 "@catalog/Other Rooms/outdoor/Landscaping/Garden styles": "Стили сада",
 "@catalog/Other Rooms/outdoor/Landscaping/Garden styles/Traditional Formal Garden": "Традиционный формальный сад",
 "@catalog/Other Rooms/outdoor/Landscaping/Garden styles/English Cottage Garden": "Английский коттеджный сад",
 "@catalog/Other Rooms/outdoor/Landscaping/Garden styles/Modern Minimalist Garden": "Минималистичный сад",
 "@catalog/Other Rooms/outdoor/Landscaping/Garden styles/Potager Garden": "Сад-огород",
 "@catalog/Other Rooms/outdoor/Landscaping/Garden styles/Asian Zen Garden": "Азиатский дзен-сад",
 "@catalog/Other Rooms/outdoor/Landscaping/Garden styles/Tropical Garden": "Тропический сад",
 "@catalog/Other Rooms/outdoor/Landscaping/Garden styles/Mediterranean Garden": "Средиземноморский сад",
 "@catalog/Other Rooms/outdoor/Landscaping/Garden styles/Coastal Garden": "Прибрежный сад",
 "@catalog/Other Rooms/outdoor/Landscaping/Garden styles/Woodland Garden": "Лесной сад",
 "@catalog/Other Rooms/outdoor/Landscaping/Garden styles/Native Prairie Garden": "Сад прерий",
 "@catalog/Other Rooms/outdoor/Landscaping/Garden styles/Xeriscape Garden": "Пустынный сад",
 "@catalog/Other Rooms/outdoor/Landscaping/Garden styles/Southwestern Desert Garden": "Юго-западный пустынный сад",
 "@catalog/Other Rooms/outdoor/Landscaping/Garden Decor": "Садовый декор",
 "@catalog/Other Rooms/outdoor/Landscaping/Garden Vases": "Садовые вазы",
 "@catalog/Other Rooms/outdoor/Landscaping/Sculpture": "Скульптура",
 "@catalog/Other Rooms/outdoor/Landscaping/Bridge": "Мост",
 "@catalog/Other Rooms/homeoffice": "Кабинет",
 "@catalog/Other Rooms/homeoffice/Office storage": "Офисные стеллажи",
 "@catalog/Other Rooms/homeoffice/Whiteboard": "Офисная доска",
 "@catalog/Other Rooms/garage": "Гараж",
 "@catalog/Other Rooms/garage/Transport": "Транспорт",
 "@catalog/Other Rooms/garage/Transport/Cars": "Автомобили",
 "@catalog/Other Rooms/garage/Transport/Bikes": "Мотоциклы",
 "@catalog/Other Rooms/garage/Transport/Stroller": "Коляска",
 "@catalog/Other Rooms/garage/Transport/SportTransport": "Спорт",
 "@catalog/Other Rooms/garage/Garage decor": "Гаражные аксессуары",
 "@catalog/Other Rooms/laundry": "Прачечная",
 "@catalog/Other Rooms/laundry/Sink": "Раковина",
 "@catalog/Other Rooms/laundry/Sink#Kitchen Sinks": "Мойки",
 "@catalog/Other Rooms/laundry/Sink#Sink cabinet": "Шкаф с раковиной",
 "@catalog/Other Rooms/laundry/Sink#Built-in Sink": "Встроенная раковина",
 "@catalog/Other Rooms/laundry/Sink#Single Sink": "Одинарная раковина",
 "@catalog/Other Rooms/laundry/Sink#Double Sink": "Двойная мойка",
 "@catalog/Other Rooms/laundry/Sink#Pedestal Sink": "Раковина-тюльпан",
 "@catalog/Other Rooms/laundry/Sink#Wall Sink": "Настенная раковина",
 "@catalog/Other Rooms/laundry/Sink#Wall Tap": "Настенный кран",
 "@catalog/Other Rooms/laundry/Sink#Faucet": "Смеситель",
 "@catalog/Other Rooms/laundry/Sink#Sink Bowl": "Чаша раковины",
 "@catalog/Other Rooms/laundry/Bath Accessories": "Аксессуары",
 "@catalog/Other Rooms/laundry/Bath Accessories/Towel rack": "Вешалка для полотенца",
 "@catalog/Other Rooms/laundry/Bath Accessories/Towel rack#Towels": "Полотенца",
 "@catalog/Other Rooms/laundry/Bath Accessories/Towel rack#Towel racks": "Полотенцедержатели",
 "@catalog/Other Rooms/laundry/Bath Accessories/Towel rack#Towel stands": "Стойки для полотенец",
 "@catalog/Other Rooms/laundry/Bath Accessories/Bathroom Decor": "Декор ванной",
 "@catalog/Other Rooms/laundry/Bath Accessories/Bathroom Decor#Bathroom Decor Table Top": "Столешница",
 "@catalog/Other Rooms/laundry/Bath Accessories/Bathroom Decor#Wall Bathroom Decor": "Настенный",
 "@catalog/Other Rooms/laundry/Bath Accessories/Soap and shampoo": "Мыло и шампунь",
 "@catalog/Other Rooms/laundry/Bath Accessories/Soap and shampoo#Soaps": "Soaps",
 "@catalog/Other Rooms/laundry/Bath Accessories/Soap and shampoo#Shampoo": "Shampoo",
 "@catalog/Other Rooms/laundry/Bath Accessories/Soap and shampoo#Soap Holder": "Soap Holder",
 "@catalog/Other Rooms/laundry/Bath Accessories/Toilet Paper Holder": "Держатель туалетной бумаги",
 "@catalog/Other Rooms/laundry/Bath Accessories/Cosmetics": "Косметика",
 "@catalog/Other Rooms/laundry/Bath Accessories/Toilet Brush": "Щетка для унитаза",
 "@catalog/Other Rooms/laundry/Bath Accessories/Toothbrush holder": "Держатель щеток",
 "@catalog/Other Rooms/laundry/Bath Accessories/Safety rack": "Защитный поручень",
 "@catalog/Other Rooms/laundry/Bath Accessories/Toilet Seat": "Сиденье для унитаза",
 "@catalog/Other Rooms/laundry/Bath Accessories/Hair Dryers": "Hair Dryers",
 "@catalog/Other Rooms/laundry/Bath Accessories/Hand Dryers": "Hand Dryers",
 "@catalog/Other Rooms/cafe": "Кафе и бар",
 "@catalog/Other Rooms/cafe/Cafe Furniture": "Предметы для кафе",
 "@catalog/Other Rooms/salon": "Салон красоты",
 "@catalog/Other Rooms/salon/Beauty salon": "Салон красоты",
 "@catalog/Other Rooms/salon/Beauty chairs": "Beauty chairs",
 "@catalog/Other Rooms/event": "Зал для мероприятий",
 "@catalog/Other Rooms/event/Events": "События",
 "@catalog/Decoration": "Декор",
 "@catalog/Decoration/Plants and Vases": "Растения и вазы",
 "@catalog/Decoration/Plants and Vases/Home plants": "Домашние растения",
 "@catalog/Decoration/Plants and Vases/Home plants#Table plants": "Table plants",
 "@catalog/Decoration/Plants and Vases/Home plants#Succulents": "Суккуленты",
 "@catalog/Decoration/Plants and Vases/Home plants#Wall-mount plants": "Wall-mount plants",
 "@catalog/Decoration/Plants and Vases/Home plants#Floor plants": "Напольные растения",
 "@catalog/Decoration/Plants and Vases/Home plants#Ceiling-mount plants": "Подвесные растения",
 "@catalog/Decoration/Plants and Vases/Vases": "Вазы",
 "@catalog/Decoration/Plants and Vases/Vases#Table vase": "Настольная ваза",
 "@catalog/Decoration/Plants and Vases/Vases#Floor vase": "Напольная ваза",
 "@catalog/Decoration/Plants and Vases/Plant stands": "Стойки для растений",
 "@catalog/Decoration/Plants and Vases/Flowers": "Цветы",
 "@catalog/Decoration/Plants and Vases/Phytowall": "Фитостена",
 "@catalog/Decoration/Plants and Vases/Outdoor plants": "Уличные растения",
 "@catalog/Decoration/Plants and Vases/Trees": "Деревья",
 "@catalog/Decoration/Plants and Vases/Bushes": "Кусты",
 "@catalog/Decoration/Wall Art": "Настенный декор",
 "@catalog/Decoration/Wall Art/Pictures": "Картины",
 "@catalog/Decoration/Wall Art/Pictures#Framed Art": "Картины в рамке",
 "@catalog/Decoration/Wall Art/Pictures#No Frame Art": "Картины без рамки",
 "@catalog/Decoration/Wall Art/Pictures#Table Frames": "Рамки для столов",
 "@catalog/Decoration/Wall Art/Pictures#Wall Art Set": "Сеты картин",
 "@catalog/Decoration/Wall Art/Pictures#Classic Art": "Классические картины",
 "@catalog/Decoration/Wall Art/Pictures#Photo Art": "Фото",
 "@catalog/Decoration/Wall Art/Pictures#Text Art": "Текстовые картины",
 "@catalog/Decoration/Wall Art/Pictures#Kids Art": "Детские картины",
 "@catalog/Decoration/Wall Art/Pictures#Round Art": "Круглые картины",
 "@catalog/Decoration/Wall Art/Pictures#Sea Art": "Морские картины",
 "@catalog/Decoration/Wall Art/Pictures#Asian Art": "Азиатское искусство",
 "@catalog/Decoration/Wall Art/Pictures#Abstract Art": "Абстрактное искусство",
 "@catalog/Decoration/Wall Art/Pictures#Modern Art": "Картины модерн",
 "@catalog/Decoration/Wall Art/Pictures#Oil Paintings": "Картины маслом",
 "@catalog/Decoration/Wall Art/Pictures#Wood Art": "Деревянные картины",
 "@catalog/Decoration/Wall Art/Pictures#Maps": "Настенные карты",
 "@catalog/Decoration/Wall Art/Pictures#Reproductions": "Репродукции",
 "@catalog/Decoration/Wall Art/Pictures#Canvas Painting": "Canvas Painting",
 "@catalog/Decoration/Wall Art/Walldecor": "Настенный декор",
 "@catalog/Decoration/Wall Art/Posters": "Плакаты",
 "@catalog/Decoration/Wall Art/Posters#Celebrities": "Звезды",
 "@catalog/Decoration/Wall Art/Posters#Movies Poster": "Фильмы,шоу",
 "@catalog/Decoration/Wall Art/Posters#Music Poster": "Музыка",
 "@catalog/Decoration/Wall Art/Posters#K-Pop Poster": "Корейские",
 "@catalog/Decoration/Wall Art/Posters#Anime Poster": "Аниме",
 "@catalog/Decoration/Wall Art/Posters#Plants Poster": "Растения",
 "@catalog/Decoration/Wall Art/Posters#Fashion Poster": "Мода",
 "@catalog/Decoration/Wall Art/Posters#Wildlife Poster": "Природа",
 "@catalog/Decoration/Wall Art/Posters#Minimalism Poster": "Минимализм",
 "@catalog/Decoration/Wall Art/Posters#Abstract Poster": "Абстракция",
 "@catalog/Decoration/Wall Art/Posters#Typography Poster": "Типографика",
 "@catalog/Decoration/Wall Art/Posters#Art Poster": "Искусство",
 "@catalog/Decoration/Wall Art/Posters#Vintage Poster": "Винтаж",
 "@catalog/Decoration/Wall Art/Posters#Cartoon Poster": "Мультфильмы",
 "@catalog/Decoration/Wall Art/Posters#Sport Poster": "Спорт",
 "@catalog/Decoration/Wall Art/Posters#Infographic": "Инфографика",
 "@catalog/Decoration/Wall Art/Wall Clocks": "Настенные часы",
 "@catalog/Decoration/Wall Art/Wall Stickers": "Настенные наклейки",
 "@catalog/Decoration/Wall Art/Flags and Tapestries": "Флаги и гобелены",
 "@catalog/Decoration/Wall Art/Signboards": "Вывески",
 "@catalog/Decoration/Rugs": "Ковры",
 "@catalog/Decoration/Rugs#Regular Rug": "Ковролин",
 "@catalog/Decoration/Rugs#Runner": "Дорожка",
 "@catalog/Decoration/Rugs#Round Rug": "Круглый ковер",
 "@catalog/Decoration/Rugs#Kids Rug": "Детский коврик",
 "@catalog/Decoration/Rugs#Door Mat": "Дверной коврик",
 "@catalog/Decoration/Rugs#Bath Mat": "Коврик для ванной",
 "@catalog/Decoration/Rugs#Prayer Mat": "Молитвенный коврик",
 "@catalog/Decoration/Rugs#Abstract Rug": "Abstract Rug",
 "@catalog/Decoration/Mirrors": "Зеркала",
 "@catalog/Decoration/Mirrors/Wall Mirrors": "Настенные зеркала",
 "@catalog/Decoration/Mirrors/Wall Mirrors#Square Mirrors": "Квадратные зеркала",
 "@catalog/Decoration/Mirrors/Wall Mirrors#Rectangle Mirrors": "Прямоугольные зеркала",
 "@catalog/Decoration/Mirrors/Wall Mirrors#Round Mirrors": "Круглые зеркала",
 "@catalog/Decoration/Mirrors/Wall Mirrors#Oval Mirrors": "Овальные зеркала",
 "@catalog/Decoration/Mirrors/Wall Mirrors#Arched Mirrors": "Арочные зеркала",
 "@catalog/Decoration/Mirrors/Wall Mirrors#Accent Mirrors": "Акцентные зеркала",
 "@catalog/Decoration/Mirrors/Wall Mirrors#Kids Mirrors": "Детские зеркала",
 "@catalog/Decoration/Mirrors/Wall Mirrors#Backlight Mirrors": "Подсветка зеркал",
 "@catalog/Decoration/Mirrors/Floor Mirrors": "Напольные зеркала",
 "@catalog/Decoration/Mirrors/Table Mirrors": "Настольные зеркала",
 "@catalog/Decoration/Materials and Constructions": "Материалы и конструкции",
 "@catalog/Decoration/Materials and Constructions/Materials": "Материалы",
 "@catalog/Decoration/Materials and Constructions/Materials/Other": "Другой",
 "@catalog/Decoration/Materials and Constructions/Materials/Wood": "Дерево",
 "@catalog/Decoration/Materials and Constructions/Materials/Marble": "Мрамор",
 "@catalog/Decoration/Materials and Constructions/Materials/Tile": "Плитка",
 "@catalog/Decoration/Materials and Constructions/Materials/Slats": "Ламели",
 "@catalog/Decoration/Materials and Constructions/Materials/Fabric": "Ткань",
 "@catalog/Decoration/Materials and Constructions/Materials/Wallpapers": "Обои",
 "@catalog/Decoration/Materials and Constructions/Materials/Finishes": "Отделка",
 "@catalog/Decoration/Materials and Constructions/Materials/Paneling": "Панели",
 "@catalog/Decoration/Materials and Constructions/Materials/Parquet or Laminate": "Паркет, ламинат",
 "@catalog/Decoration/Materials and Constructions/Materials/Glass": "Стекло",
 "@catalog/Decoration/Materials and Constructions/Materials/Stone": "Камень",
 "@catalog/Decoration/Materials and Constructions/Materials/Bricks": "Кирпичи",
 "@catalog/Decoration/Materials and Constructions/Materials/Carpet": "Ковролин",
 "@catalog/Decoration/Materials and Constructions/Materials/MaterialPlants": "Растения",
 "@catalog/Decoration/Materials and Constructions/Materials/Metal": "Металл",
 "@catalog/Decoration/Materials and Constructions/Materials/Photo Wallpaper": "Фотообои",
 "@catalog/Decoration/Materials and Constructions/Materials/Ground": "Земля",
 "@catalog/Decoration/Materials and Constructions/Materials/Granite": "Гранит",
 "@catalog/Decoration/Materials and Constructions/Materials/Neon": "Неон",
 "@catalog/Decoration/Materials and Constructions/Materials/Water": "Вода",
 "@catalog/Decoration/Materials and Constructions/Materials/Sky": "Небо",
 "@catalog/Decoration/Materials and Constructions/Materials/Rattan": "Ротанг",
 "@catalog/Decoration/Materials and Constructions/Materials/Leather": "Кожа",
 "@catalog/Decoration/Materials and Constructions/Materials/Roof": "Крыша",
 "@catalog/Decoration/Materials and Constructions/Materials/SciFi": "Sci-Fi",
 "@catalog/Decoration/Materials and Constructions/Columns": "Колонны",
 "@catalog/Decoration/Materials and Constructions/Screens, Paravents": "Ширмы, паравенты",
 "@catalog/Decoration/Materials and Constructions/PlinthsAndMoldings": "Плинтусы и молдинги",
 "@catalog/Decoration/Materials and Constructions/PlinthsAndMoldings/Moldings": "Молдинги",
 "@catalog/Decoration/Materials and Constructions/DecorCeiling": "Потолочные украшения",
 "@catalog/Decoration/Table Decor": "Декор для стола",
 "@catalog/Decoration/Table Decor/Vases": "Вазы",
 "@catalog/Decoration/Table Decor/Room decor": "Декор",
 "@catalog/Decoration/Table Decor/Candles": "Свечи",
 "@catalog/Decoration/Table Decor/Statues": "Статуи",
 "@catalog/Decoration/Table Decor/Tableware": "Столовая посуда",
 "@catalog/Decoration/Table Decor/Tableware/Cups and glasses": "Чашки и стаканы",
 "@catalog/Decoration/Table Decor/Tableware/Plates": "Тарелки",
 "@catalog/Decoration/Table Decor/Tableware/Drinks": "Напитки",
 "@catalog/Decoration/Table Decor/Tableware/Serving": "Сервировка",
 "@catalog/Decoration/Table Decor/Tableware/Desserts": "Десерты",
 "@catalog/Decoration/Table Decor/Tableware/Food": "Еда",
 "@catalog/Decoration/Table Decor/Table Clocks": "Настольные часы",
 "@catalog/Decoration/Table Decor/Table Mirrors": "Зеркала",
 "@catalog/Decoration/Work and Study": "Работа и учеба",
 "@catalog/Decoration/Work and Study/Books": "Книги",
 "@catalog/Decoration/Work and Study/Office Accessories": "Офисный декор",
 "@catalog/Decoration/Work and Study/Memo Boards": "Доска для заметок",
 "@catalog/Decoration/Work and Study/Clocks": "Часы",
 "@catalog/Decoration/Work and Study/Whiteboards": "Доски",
 "@catalog/Decoration/Organizers and Bins": "Органайзеры и ящики",
 "@catalog/Decoration/Organizers and Bins/Decorative Baskets": "Декоративные корзины",
 "@catalog/Decoration/Organizers and Bins/Trash bin": "Мусорные ведра",
 "@catalog/Decoration/Organizers and Bins/Storage Boxes": "Ящики для хранения",
 "@catalog/Decoration/Organizers and Bins/Tray": "Подносы",
 "@catalog/Decoration/Kids Decor": "Детский декор",
 "@catalog/Decoration/Kids Decor/Toys": "Игрушки",
 "@catalog/Decoration/Kids Decor/KidsDecor": "Детский декор",
 "@catalog/Decoration/Kids Decor/Kids Art": "Детские картины",
 "@catalog/Decoration/Kids Decor/Kids Rugs": "Детские коврики",
 "@catalog/Decoration/Kids Decor/Kids Mirrors": "Детские зеркала",
 "@catalog/Decoration/Curtains and Dividers": "Шторы и перегородки",
 "@catalog/Decoration/Curtains and Dividers/CeilingCurtains": "Потолочные шторы",
 "@catalog/Decoration/Curtains and Dividers/Window Curtains": "Оконные шторы",
 "@catalog/Decoration/Curtains and Dividers/Screens, Paravents": "Ширмы, паравенты",
 "@catalog/Decoration/Characters and Pets": "Персонажи и питомцы",
 "@catalog/Decoration/Characters and Pets/Pets": "Животные",
 "@catalog/Decoration/Characters and Pets/Pets#Cat": "Кот",
 "@catalog/Decoration/Characters and Pets/Pets#Dog": "Собака",
 "@catalog/Decoration/Characters and Pets/Pets#Fish": "Fish",
 "@catalog/Decoration/Characters and Pets/Pets#Other Pets": "Other Pets",
 "@catalog/Decoration/Characters and Pets/Characters": "Персонажи",
 "@catalog/Decoration/Characters and Pets/Characters#Men": "Мужчины",
 "@catalog/Decoration/Characters and Pets/Characters#Women": "Женщины",
 "@catalog/Decoration/Characters and Pets/Characters#Kids": "Дети",
 "@catalog/Decoration/Characters and Pets/Characters#Groups": "Группы",
 "@catalog/Decoration/Characters and Pets/Characters#Special Characters": "Особое",
 "@catalog/Decoration/Characters and Pets/Pet Supplies": "Товары для питомцев",
 "@catalog/Decoration/Characters and Pets/Pet Supplies#Pet Bed": "Beds",
 "@catalog/Decoration/Characters and Pets/Pet Supplies#Pet House": "Домик для питомца",
 "@catalog/Decoration/Characters and Pets/Pet Supplies#Pet Feeder": "Кормушка для питомца",
 "@catalog/Decoration/Characters and Pets/Pet Supplies#Pet Accessories": "Аксессуары",
 "@catalog/Decoration/Holiday Decor": "Праздничный декор",
 "@catalog/Decoration/Holiday Decor/Wedding": "Свадьба",
 "@catalog/Decoration/Holiday Decor/Christmas": "Рождество",
 "@catalog/Decoration/Holiday Decor/Halloween": "Хеллоуин",
 "@catalog/Storage": "Шкафы, полки",
 "@catalog/Storage/Wardrobe": "Шкаф-купе",
 "@catalog/Storage/Wardrobe#Sliding Door Wardrobe": "Шкаф-купе",
 "@catalog/Storage/Wardrobe#Clothes Rack": "Вешалка",
 "@catalog/Storage/Wardrobe#Wardrobe cabinet": "Шкаф-гардероб",
 "@catalog/Storage/Wardrobe#Wardrobe System": "Гардеробная система",
 "@catalog/Storage/Base Cabinets": "Нижние шкафы",
 "@catalog/Storage/Sink": "Раковина",
 "@catalog/Storage/Shelving": "Стеллаж",
 "@catalog/Storage/Shelving#Bookshelve": "Книжная полка",
 "@catalog/Storage/Shelving#Pantry": "Стеллаж",
 "@catalog/Storage/Shelving#Wall pantry": "Настенный пенал",
 "@catalog/Storage/Shelving#Storage rack": "Стеллаж",
 "@catalog/Storage/Shelving#Corner shelves": "Угловые полки",
 "@catalog/Storage/Shelving#Ladder shelf": "Полка-лестница",
 "@catalog/Storage/Shelving#Lower Shelving": "Нижние полки",
 "@catalog/Storage/Wall shelve": "Настенная полка",
 "@catalog/Storage/Wall shelve#Corner shelve": "Угловая полка",
 "@catalog/Storage/Wall shelve#Art shelve": "Арт-полка",
 "@catalog/Storage/Wall shelve#Paper shelve": "Полка для бумаги",
 "@catalog/Storage/Wall shelve#Square shelve": "Квадратная полка",
 "@catalog/Storage/Wall shelve#Open shelve": "Открытая полка",
 "@catalog/Storage/Wall shelve#Closed shelve": "Закрытая полка",
 "@catalog/Storage/Wall shelve#Kitchen shelve": "Кухонная полка",
 "@catalog/Storage/Wall shelve#Storage unit": "Модуль хранения",
 "@catalog/Storage/Kitchen Island": "Кухонный остров",
 "@catalog/Storage/TV Storage": "Хранение ТВ",
 "@catalog/Storage/TV Storage#TV Stands": "TV Stands",
 "@catalog/Storage/TV Storage#Wall Units": "Wall Units",
 "@catalog/Storage/TV Storage#Entertainment Centers": "Entertainment Centers",
 "@catalog/Storage/Wall Cabinets": "Настенные шкафы",
 "@catalog/Storage/Built In Storage": "Встроенное хранение",
 "@catalog/Storage/Dressers": "Ящики",
 "@catalog/Storage/Dressers#Drawer": "Комод",
 "@catalog/Storage/Dressers#Drawer Chest": "Комод",
 "@catalog/Storage/Dressers#Dresser": "Комод",
 "@catalog/Storage/CabinetsRegular": "Шкафчики",
 "@catalog/Storage/CabinetsRegular#Secretary": "Письменный стол",
 "@catalog/Storage/CabinetsRegular#Corner cabinet Low": "Угловой шкаф",
 "@catalog/Storage/CabinetsRegular#Staircase cabinet": "Шкаф-лестница",
 "@catalog/Storage/Shoe storage": "Обувные шкафы",
 "@catalog/Storage/Shoe storage#Shoe Rack": "Обувная полка",
 "@catalog/Storage/Shoe storage#Shoe Benches": "Обувные скамьи",
 "@catalog/Storage/Shoe storage#Shoe Tower": "Высокие обувницы",
 "@catalog/Storage/Shoe storage#Mounted Unit": "Обувница",
 "@catalog/Storage/Shoe storage#Shoe Organizer": "Органайзер для обуви",
 "@catalog/Storage/WallCabinetsRegular": "Навесные шкафы",
 "@catalog/Storage/WallCabinetsRegular#Single Door Cabinets": "Однодверный",
 "@catalog/Storage/WallCabinetsRegular#Double Door Cabinets": "Двухдверный",
 "@catalog/Storage/WallCabinetsRegular#Glass Door Cabinets": "Стеклянные",
 "@catalog/Storage/WallCabinetsRegular#Mirrored Door Cabinets": "С зеркалом",
 "@catalog/Storage/WallCabinetsRegular#Open Shelve Cabinets": "С полками",
 "@catalog/Storage/WallCabinetsRegular#Corner Cabinets": "Угловые шкафы",
 "@catalog/Storage/WallCabinetsRegular#Cabinet Sets": "Комплекты шкафов",
 "@catalog/Storage/Countertops": "Столешницы",
 "@catalog/Storage/Clothes": "Одежда",
 "@catalog/Storage/Clothes#Cloth": "Одежда",
 "@catalog/Storage/Clothes#Shoes": "Shoes",
 "@catalog/Storage/Clothes#Bags": "Сумки",
 "@catalog/Storage/Clothes#Hats": "Головные уборы",
 "@catalog/Storage/Clothes#Accessories": "Аксессуары",
 "@catalog/Storage/High Cabinets": "Высокие шкафы",
 "@catalog/Storage/HighCabinetsRegular": "High cabinets",
 "@catalog/Storage/HighCabinetsRegular#Single High Cabinets": "Одинарные высокие шкафы",
 "@catalog/Storage/HighCabinetsRegular#Double High Cabinets": "Двойные высокие шкафы",
 "@catalog/Storage/HighCabinetsRegular#Open High Cabinets": "Открытые высокие шкафы",
 "@catalog/Storage/Tall cabinets": "Высокие шкафы",
 "@catalog/Storage/Tall cabinets#Bookcase": "Книжный шкаф",
 "@catalog/Storage/Tall cabinets#Corner cabinet High": "Угловой шкаф",
 "@catalog/Storage/Coat stand": "Вешалка",
 "@catalog/Storage/Coat stand#Free-standing": "Напольная вешалка",
 "@catalog/Storage/Coat stand#Hallway Units": "Прихожие модули",
 "@catalog/Storage/Coat stand#Umbrella Stand": "Подставка для зонтов",
 "@catalog/Storage/Hanger": "Вешалка",
 "@catalog/Storage/Hanger#Hooks": "Крючки",
 "@catalog/Storage/Hanger#Hook Rails": "Рейки с крючками",
 "@catalog/Storage/Hanger#Wall Mount Hanger": "Настенная вешалка",
 "@catalog/Storage/Hanger#Accent Hanger": "Акцентная вешалка",
 "@catalog/Storage/Moldings": "Молдинги",
 "@catalog/Storage/Hutch": "Сервант",
 "@catalog/Storage/Office storage": "Офисные стеллажи",
 "@catalog/Storage/Kids Storage": "Детские шкафы",
 "@catalog/Storage/Showcase": "Витрина",
 "@catalog/Storage/Locker": "Шкафчик",
 "@catalog/Storage/Sideboards": "Тумба",
 "@catalog/Storage/Sideboards#Sideboard": "Тумба",
 "@catalog/Storage/Sideboards#Console Table": "Console Table",
 "@catalog/Storage/Sideboards#Credenza": "Буфет",
 "@catalog/Storage/Sideboards#Server": "Сервер",
 "@catalog/Storage/Sideboards#Buffet": "Буфет",
 "@catalog/Storage/Room divider": "Перегородка",
 "@catalog/Storage/Room divider#Room partition": "Перегородка",
 "@catalog/Storage/Room divider#Paravent": "Паравент",
 "@catalog/Storage/Room divider#Storage partition": "Стеллаж-перегородка",
 "@catalog/Storage/Knobs,handles": "Ручки",
 "@catalog/Storage/Knobs,handles#Entry Locks": "Дверные замки",
 "@catalog/Storage/Knobs,handles#Door Levers": "Дверные ручки",
 "@catalog/Storage/Knobs,handles#Cabinet Pulls": "Ручки шкафов",
 "@catalog/Storage/Knobs,handles#Cabinet Knobs": "Ручки-кнопки шкафов",
 "@catalog/Storage/Wine Cabinets": "Винные шкафы",
 "@catalog/Storage/Kitchen Cart": "Кухонная тележка",
 "@catalog/TablesAndChairs": "Столы и стулья",
 "@catalog/TablesAndChairs/Desk": "Рабочий стол",
 "@catalog/TablesAndChairs/Desk#Writing Desk": "Письменный стол",
 "@catalog/TablesAndChairs/Desk#Executive Desk": "Представительский стол",
 "@catalog/TablesAndChairs/Desk#Simple Table": "Simple Table",
 "@catalog/TablesAndChairs/Desk#Laptop Stand": "Подставка для ноутбука",
 "@catalog/TablesAndChairs/Desk#Floating Desk": "Настенный стол",
 "@catalog/TablesAndChairs/Desk#Junior Table": "Детский стол",
 "@catalog/TablesAndChairs/Desk#Work Station": "Рабочая станция",
 "@catalog/TablesAndChairs/Desk#Standing Desk": "Стол с ножками",
 "@catalog/TablesAndChairs/Desk#Ladder Desk": "Стол-лестница",
 "@catalog/TablesAndChairs/Desk#Corner Desk": "Угловой стол",
 "@catalog/TablesAndChairs/Desk#Conference Table": "Конференц-стол",
 "@catalog/TablesAndChairs/Kitchen Island": "Кухонный остров",
 "@catalog/TablesAndChairs/Kitchen Island#Rectangular Island": "Прямоугольный остров",
 "@catalog/TablesAndChairs/Kitchen Island#Round Island": "Круглый остров",
 "@catalog/TablesAndChairs/Kitchen Island#Small Island": "Небольшой остров",
 "@catalog/TablesAndChairs/Kitchen Island#Integrated Island": "Остров с техникой",
 "@catalog/TablesAndChairs/Kitchen Island#Island with Shelving": "Остров с полками",
 "@catalog/TablesAndChairs/Coffee table": "Столик",
 "@catalog/TablesAndChairs/Dressing table": "Туалетный столик",
 "@catalog/TablesAndChairs/Dressing table#Vanity table": "Туалетный столик",
 "@catalog/TablesAndChairs/Dressing table#Vanity Dressers": "Туалетные комоды",
 "@catalog/TablesAndChairs/Dressing table#Mirrored Vanities": "Туалетные столики с зеркалом",
 "@catalog/TablesAndChairs/Dressing table#Round Mirror Units": "Круглые зеркала",
 "@catalog/TablesAndChairs/Dressing table#Lighted Vanities": "С подсветкой",
 "@catalog/TablesAndChairs/Dressing table#Tri-fold Vanities": "Трёхстворчатые",
 "@catalog/TablesAndChairs/Dressing table#Wall-mount Vanities": "Настенные тумбы",
 "@catalog/TablesAndChairs/Dining set": "Столовая мебель",
 "@catalog/TablesAndChairs/Dining set#Set for 2": "На 2 персоны",
 "@catalog/TablesAndChairs/Dining set#Set for 3": "На 3 персоны",
 "@catalog/TablesAndChairs/Dining set#Set for 4": "На 4 персоны",
 "@catalog/TablesAndChairs/Dining set#Set for 6": "На 6 персон",
 "@catalog/TablesAndChairs/Dining set#Set for 8+": "На 8+ персон",
 "@catalog/TablesAndChairs/DiningTables": "Обеденный стол",
 "@catalog/TablesAndChairs/DiningTables#Rectangle Table": "Rectangle Table",
 "@catalog/TablesAndChairs/DiningTables#Round Table": "Round Table",
 "@catalog/TablesAndChairs/DiningTables#Square Table": "Square Table",
 "@catalog/TablesAndChairs/DiningTables#Oval Table": "Oval Table",
 "@catalog/TablesAndChairs/DiningTables#Abstract Table": "Abstract Table",
 "@catalog/TablesAndChairs/DiningTables#Sliding Table": "Sliding Table",
 "@catalog/TablesAndChairs/Office Chair": "Офисное кресло",
 "@catalog/TablesAndChairs/Side table": "Столик",
 "@catalog/TablesAndChairs/Chair": "Стул",
 "@catalog/TablesAndChairs/Chair#Non Upholstered Chair": "Стул без обивки",
 "@catalog/TablesAndChairs/Chair#Upholstered Chair": "Мягкий стул",
 "@catalog/TablesAndChairs/Chair#Folding Chair": "Складной стул",
 "@catalog/TablesAndChairs/Chair#Conference Chair": "Кресло для конференции",
 "@catalog/TablesAndChairs/Chair#School Chair": "Школьный стул",
 "@catalog/TablesAndChairs/Chair#Tulip Chair": "Стул «Тюльпан»",
 "@catalog/TablesAndChairs/Chair#Butterfly Chair": "Кресло «Бабочка»",
 "@catalog/TablesAndChairs/Chair#Swivel Chair": "Рабочий стул",
 "@catalog/TablesAndChairs/Chair#Care Chair": "Стул для ухода",
 "@catalog/TablesAndChairs/Barstool": "Барные стулья",
 "@catalog/TablesAndChairs/Barstool#SwivelBarstool": "Поворотный барный стул",
 "@catalog/TablesAndChairs/Barstool#LowBackBarstool": "Барный стул с низкой спинкой",
 "@catalog/TablesAndChairs/Barstool#FullBackBarstool": "Барный стул со спинкой",
 "@catalog/TablesAndChairs/Barstool#BacklessBarstool": "Барный табурет без спинки",
 "@catalog/TablesAndChairs/Barstool#RoundBarstool": "Круглый барный стул",
 "@catalog/TablesAndChairs/Stool": "Табурет",
 "@catalog/TablesAndChairs/Stool#Legged Stool": "Табурет с ножками",
 "@catalog/TablesAndChairs/Stool#Solid Stool": "Цельный табурет",
 "@catalog/TablesAndChairs/Stool#Square Stool": "Квадратный табурет",
 "@catalog/TablesAndChairs/Stool#Round Stool": "Круглая табуретка",
 "@catalog/TablesAndChairs/Stool#Backrest Stool": "Табуретка со спинкой",
 "@catalog/TablesAndChairs/Stool#Upholstered Stool": "Мягкая табуретка",
 "@catalog/TablesAndChairs/Stool#Accent Stool": "Акцентная табуретка",
 "@catalog/TablesAndChairs/Bar Table": "Барный стол",
 "@catalog/TablesAndChairs/Bar Table#Rectangle Table": "Rectangle Table",
 "@catalog/TablesAndChairs/Bar Table#Round Table": "Round Table",
 "@catalog/TablesAndChairs/Bar Table#Square Table": "Square Table",
 "@catalog/TablesAndChairs/Bar Table#Oval Table": "Oval Table",
 "@catalog/TablesAndChairs/Outdoor Dining": "Мебель для улицы",
 "@catalog/TablesAndChairs/Outdoor Dining#Outdoor Dining Set": "Outdoor Set",
 "@catalog/TablesAndChairs/Outdoor Dining#Outdoor Dining Table": "Tables",
 "@catalog/TablesAndChairs/Outdoor Dining#Outdoor Dining Chairs": "Chairs",
 "@catalog/TablesAndChairs/Reception": "Ресепшн",
 "@catalog/TablesAndChairs/Reception#Straight Reception": "Прямая стойка",
 "@catalog/TablesAndChairs/Reception#Curved Reception": "Изогнутая стойка",
 "@catalog/TablesAndChairs/Reception#L-shape Reception": "Г-образная стойка",
 "@catalog/TablesAndChairs/Reception#U-shape Reception": "П-образная стойка",
 "@catalog/TablesAndChairs/Reception#Stone Reception": "Каменная стойка",
 "@catalog/TablesAndChairs/Reception#Wooden Reception": "Деревянная стойка",
 "@catalog/TablesAndChairs/Kids furniture": "Детская мебель",
 "@catalog/TablesAndChairs/Kids furniture/Kids Table Sets": "Сеты",
 "@catalog/TablesAndChairs/Kids furniture/Kids Tables": "Детские столы",
 "@catalog/TablesAndChairs/Kids furniture/Kids Chairs": "Детские стулья",
 "@catalog/TablesAndChairs/Kids furniture/Junior Chair": "Детский стул",
 "@catalog/TablesAndChairs/Kids furniture/Kids Desk": "Детский стол",
 "@catalog/TablesAndChairs/Coworking": "Коворкинг места",
 "@catalog/TablesAndChairs/Coworking#Coworking seats": "Коворкинг места",
 "@catalog/TablesAndChairs/Coworking#Cubicle": "Офисный уголок",
 "@catalog/TablesAndChairs/Coworking#Office Set": "Для офиса",
 "@catalog/TablesAndChairs/High Chair": "Высокий стул",
 "@catalog/TablesAndChairs/Step stool": "Табурет-стремянка",
 "@catalog/Electronic Devices": "Электронные устройства",
 "@catalog/Electronic Devices/TV / Media": "ТВ / Медиа",
 "@catalog/Electronic Devices/TV / Media/Wall TV": "Настенный телевизор",
 "@catalog/Electronic Devices/TV / Media/TV Storage": "Хранение ТВ",
 "@catalog/Electronic Devices/TV / Media/Table TV": "ТВ",
 "@catalog/Electronic Devices/TV / Media/TV set-top box": "ТВ-приставка",
 "@catalog/Electronic Devices/TV / Media/Sound": "Звуковое оборудование",
 "@catalog/Electronic Devices/TV / Media/Projector": "Проектор",
 "@catalog/Electronic Devices/KitchenAppliances": "Кухонные приборы",
 "@catalog/Electronic Devices/KitchenAppliances/Refrigerators": "Холодильники",
 "@catalog/Electronic Devices/KitchenAppliances/Refrigerators#Side-by-Side Fridge": "Side-by-Side Fridge",
 "@catalog/Electronic Devices/KitchenAppliances/Refrigerators#Mini Fridge": "Mini Fridge",
 "@catalog/Electronic Devices/KitchenAppliances/Refrigerators#Top Freezer Fridge": "Top Freezer Fridge",
 "@catalog/Electronic Devices/KitchenAppliances/Refrigerators#Beverage Fridge": "Холодильник для напитков",
 "@catalog/Electronic Devices/KitchenAppliances/Cooktop": "Варочные панели",
 "@catalog/Electronic Devices/KitchenAppliances/Cooktop#Gas Cooktop": "Gas Cooktop",
 "@catalog/Electronic Devices/KitchenAppliances/Cooktop#Electric Cooktop": "Electric Cooktop",
 "@catalog/Electronic Devices/KitchenAppliances/Cooker Hood": "Вытяжки",
 "@catalog/Electronic Devices/KitchenAppliances/Cooker Hood#Canopy Hood": "Купольная вытяжка",
 "@catalog/Electronic Devices/KitchenAppliances/Cooker Hood#T-shaped Hood": "T-shaped Hood",
 "@catalog/Electronic Devices/KitchenAppliances/Cooker Hood#Telescopic Hood": "Телескопическая вытяжка",
 "@catalog/Electronic Devices/KitchenAppliances/Cooker Hood#Builtin Hood": "Builtin Hood",
 "@catalog/Electronic Devices/KitchenAppliances/Cooker Hood#Island Hood": "Island Hood",
 "@catalog/Electronic Devices/KitchenAppliances/Cooker Hood#Angled Hood": "Angled Hood",
 "@catalog/Electronic Devices/KitchenAppliances/Ovens": "Духовки",
 "@catalog/Electronic Devices/KitchenAppliances/Ovens#Range": "Range",
 "@catalog/Electronic Devices/KitchenAppliances/Ovens#Gas Oven": "Gas Oven",
 "@catalog/Electronic Devices/KitchenAppliances/Ovens#Electric Oven": "Electric Oven",
 "@catalog/Electronic Devices/KitchenAppliances/Ovens#Combined Oven": "Комбинированная духовка",
 "@catalog/Electronic Devices/KitchenAppliances/Ovens#Builtin Oven": "Builtin Oven",
 "@catalog/Electronic Devices/KitchenAppliances/Coffee Maker": "Кофеварка",
 "@catalog/Electronic Devices/KitchenAppliances/Microwave": "Микроволновка",
 "@catalog/Electronic Devices/KitchenAppliances/KitchenTableElectronics": "Больше кухонных приборов",
 "@catalog/Electronic Devices/KitchenAppliances/Water purifier": "Водоочиститель",
 "@catalog/Electronic Devices/KitchenAppliances/Dishwashers": "Посудомоечные машины",
 "@catalog/Electronic Devices/KitchenAppliances/Kettle": "Чайник",
 "@catalog/Electronic Devices/KitchenAppliances/Multi cooker,Rice cooker": "Мультиварка, рисоварка",
 "@catalog/Electronic Devices/KitchenAppliances/Toaster": "Тостер",
 "@catalog/Electronic Devices/KitchenAppliances/Blender,Mixer,Food processor": "Кухонный комбайн",
 "@catalog/Electronic Devices/KitchenAppliances/Drying cabinet": "Сушильный шкаф",
 "@catalog/Electronic Devices/Climate electronics": "Климатическая электроника",
 "@catalog/Electronic Devices/Climate electronics/Conditioner": "Кондиционер",
 "@catalog/Electronic Devices/Climate electronics/Ceiling fan": "Потолочный вентилятор",
 "@catalog/Electronic Devices/Climate electronics/Heating": "Отопление",
 "@catalog/Electronic Devices/Climate electronics/Heating#Wall Radiator": "Настенный радиатор",
 "@catalog/Electronic Devices/Climate electronics/Heating#Floor Radiator": "Напольный радиатор",
 "@catalog/Electronic Devices/Climate electronics/Heating#Towel Dryer": "Сушилка для полотенец",
 "@catalog/Electronic Devices/Climate electronics/Ventilation": "Вентиляция",
 "@catalog/Electronic Devices/Climate electronics/Fan": "Вентилятор",
 "@catalog/Electronic Devices/Climate electronics/Air purifier": "Очиститель воздуха",
 "@catalog/Electronic Devices/Climate electronics/Water heater": "Бойлер",
 "@catalog/Electronic Devices/Climate electronics/Thermometer": "Термометр",
 "@catalog/Electronic Devices/LightingOutletsSwitches": "Розетки, выключатели",
 "@catalog/Electronic Devices/Washers / Dryers": "Стир.машины",
 "@catalog/Electronic Devices/Washers / Dryers#Washing Machines": "Washing Machines",
 "@catalog/Electronic Devices/Washers / Dryers#Drying Machines": "Сушилки",
 "@catalog/Electronic Devices/Washers / Dryers#Top Load Washers": "Top Load Washers",
 "@catalog/Electronic Devices/Washers / Dryers#Laundry Sets": "Laundry Sets",
 "@catalog/Electronic Devices/Washers / Dryers#Clothes Drying": "Сушилка для одежды",
 "@catalog/Electronic Devices/Office electronics": "Офисная электроника",
 "@catalog/Electronic Devices/Office electronics#Laptops": "Ноутбуки",
 "@catalog/Electronic Devices/Office electronics#PC": "ПК",
 "@catalog/Electronic Devices/Office electronics#Monitors": "Мониторы",
 "@catalog/Electronic Devices/Office electronics#Keyboard": "Клавиатура",
 "@catalog/Electronic Devices/Office electronics#Mouse": "Мышка",
 "@catalog/Electronic Devices/Office electronics#Printer": "Принтер",
 "@catalog/Electronic Devices/Office electronics#Microphone": "Микрофон",
 "@catalog/Electronic Devices/Office electronics#Headphones": "Наушники",
 "@catalog/Electronic Devices/Gaming": "Игры",
 "@catalog/Electronic Devices/Gaming/Phones and Tablets": "Телефоны и планшеты",
 "@catalog/Electronic Devices/Gaming/Consoles": "Игровая консоль",
 "@catalog/Electronic Devices/Gaming/Gaming setups": "Игровые сборки",
 "@catalog/Electronic Devices/Gaming/Monitors": "Мониторы",
 "@catalog/Electronic Devices/Gaming/Gaming decor": "Игровой декор",
 "@catalog/Electronic Devices/Gaming/PCs": "Компьютер",
 "@catalog/Electronic Devices/Gaming/Gaming desks": "Игровые столы",
 "@catalog/Electronic Devices/Gaming/Gaming audio": "Игровой звук",
 "@catalog/Electronic Devices/Gaming/VR": "VR",
 "@catalog/Electronic Devices/Gaming/Gaming chairs": "Игровые кресла",
 "@catalog/Electronic Devices/Gaming/Laptops": "Ноутбуки",
 "@catalog/Electronic Devices/Gaming/Keyboards,Mouses": "Клавиатуры,мышки",
 "@catalog/Electronic Devices/Gaming/Keyboards,Mouses#Keyboard": "Клавиатура",
 "@catalog/Electronic Devices/Gaming/Keyboards,Mouses#Mouse": "Мышка",
 "@catalog/Electronic Devices/Gaming/TV": "Телевизор",
 "@catalog/Electronic Devices/Sound equipment": "Музыка",
 "@catalog/Electronic Devices/Sound equipment#Speaker": "Колонка",
 "@catalog/Electronic Devices/Sound equipment#Smart Speaker": "Умная колонка",
 "@catalog/Electronic Devices/Sound equipment#Microphone": "Микрофон",
 "@catalog/Electronic Devices/Sound equipment#Headphones": "Наушники",
 "@catalog/Electronic Devices/Sound equipment#Recorder": "Проигрыватель",
 "@catalog/Electronic Devices/SpecificElectronics": "Больше электроники",
 "@catalog/Electronic Devices/SpecificElectronics/Intercom": "Домофон",
 "@catalog/Electronic Devices/SpecificElectronics/Security camera": "Камера",
 "@catalog/Electronic Devices/SpecificElectronics/Router": "Роутер",
 "@catalog/Electronic Devices/SpecificElectronics/HomeAppliances": "Больше электроники",
 "@catalog/Electronic Devices/SpecificElectronics/Antenna": "Антенна",
 "@catalog/Electronic Devices/Phones and Tablets": "Телефоны и планшеты",
 "@catalog/Electronic Devices/Phones and Tablets#Phones": "Телефоны",
 "@catalog/Electronic Devices/Phones and Tablets#Mobile Phones": "Mobile Phones",
 "@catalog/Electronic Devices/Phones and Tablets#Tablets": "Tablets",
 "@catalog/Electronic Devices/Home care electronics": "Уход за домом",
 "@catalog/Electronic Devices/Home care electronics/Vacuum cleaners and mops": "Пылесосы и швабры",
 "@catalog/Electronic Devices/Home care electronics/Irons and Steamers": "Утюги и отпариватели",
 "@catalog/Electronic Devices/Commercial electronics": "Коммерческая электроника",
 "@catalog/Electronic Devices/Commercial electronics/POS system": "POS-система",
 "@catalog/Electronic Devices/Commercial electronics/Security camera": "Камера",
 "@catalog/Electronic Devices/Commercial electronics/Commercial items": "Коммерческие объекты",
 "@catalog/Electronic Devices/Commercial electronics/Water Cooler": "Кулер",
 "@catalog/Electronic Devices/Commercial electronics/Vending Machine": "Торговый автомат",
 "@catalog/Seating furniture": "Мебель для сидения",
 "@catalog/Seating furniture/Sofa": "Диван",
 "@catalog/Seating furniture/Sofa#3-Seat Sofa": "3-Seat Sofa",
 "@catalog/Seating furniture/Sofa#Loveseat Sofa": "Диванчик",
 "@catalog/Seating furniture/Sofa#L-Shaped Sofa": "L-Shaped Sofa",
 "@catalog/Seating furniture/Sofa#Modular Sofa": "Modular Sofa",
 "@catalog/Seating furniture/Sofa#Chaise Lounge": "Chaise Lounge",
 "@catalog/Seating furniture/Sofa#Chesterfield Sofa": "Диван честерфилд",
 "@catalog/Seating furniture/Sofa#Curved Sofa": "Изогнутый диван",
 "@catalog/Seating furniture/Sofa#Round Sofa": "Круглый диван",
 "@catalog/Seating furniture/Sofa#P-shaped Sofa": "P-shaped Sofa",
 "@catalog/Seating furniture/Sofa#Tuxedo Sofa": "Диван таксидо",
 "@catalog/Seating furniture/Sofa#Marshmallow Sofa": "Диван Marshmallow",
 "@catalog/Seating furniture/Sofa#Settee Sofa": "Мини-диван",
 "@catalog/Seating furniture/Sofa#Sleeper Sofa": "Диван-кровать",
 "@catalog/Seating furniture/Sofa#SofaBed": "Диван-кровать",
 "@catalog/Seating furniture/Coffee table": "Столик",
 "@catalog/Seating furniture/Coffee table#Rectangle Table": "Rectangle Table",
 "@catalog/Seating furniture/Coffee table#Round Table": "Round Table",
 "@catalog/Seating furniture/Coffee table#Square Table": "Square Table",
 "@catalog/Seating furniture/Coffee table#Oval Table": "Oval Table",
 "@catalog/Seating furniture/Coffee table#Abstract Table": "Abstract Table",
 "@catalog/Seating furniture/Coffee table#Sliding Table": "Sliding Table",
 "@catalog/Seating furniture/Armchair": "Кресло",
 "@catalog/Seating furniture/Armchair#Wingback Chair": "Кресло с крыльями",
 "@catalog/Seating furniture/Armchair#Barrel Chair": "Кресло-бочка",
 "@catalog/Seating furniture/Armchair#Club Chair": "Клубное кресло",
 "@catalog/Seating furniture/Armchair#Recliner Chair": "Кресло с откидной спинкой",
 "@catalog/Seating furniture/Armchair#Chesterfield Chair": "Кресло Честерфилд",
 "@catalog/Seating furniture/Armchair#Accent Chair": "Акцентное кресло",
 "@catalog/Seating furniture/Armchair#Slipper Chair": "Кресло без подлокотников",
 "@catalog/Seating furniture/Armchair#Armchair With Ottoman": "Armchair With Ottoman",
 "@catalog/Seating furniture/Armchair#Corner Chair": "Угловое кресло",
 "@catalog/Seating furniture/Armchair#Round Chair": "Круглое кресло",
 "@catalog/Seating furniture/Armchair#Egg Chair": "Кресло «Яйцо»",
 "@catalog/Seating furniture/Armchair#Massage Chair": "Массажное кресло",
 "@catalog/Seating furniture/Office Chair": "Офисное кресло",
 "@catalog/Seating furniture/Office Chair#Gaming Chair": "Игровой стул",
 "@catalog/Seating furniture/Office Chair#Executive Chair": "Кресло директора",
 "@catalog/Seating furniture/Office Chair#Swan Chair": "Кресло «Лебедь»",
 "@catalog/Seating furniture/Side table": "Столик",
 "@catalog/Seating furniture/Side table#Rectangle Table": "Rectangle Table",
 "@catalog/Seating furniture/Side table#Round Table": "Round Table",
 "@catalog/Seating furniture/Side table#Square Table": "Square Table",
 "@catalog/Seating furniture/Side table#Oval Table": "Oval Table",
 "@catalog/Seating furniture/Side table#Abstract Table": "Abstract Table",
 "@catalog/Seating furniture/Side table#C Table": "С-образный стол",
 "@catalog/Seating furniture/Side table#Nesting Table": "Nesting Table",
 "@catalog/Seating furniture/Chaise": "Кресло для отдыха",
 "@catalog/Seating furniture/Pouf, Footstool": "Пуф, табурет",
 "@catalog/Seating furniture/Pouf, Footstool#Ottoman,Footstool": "Оттоманка",
 "@catalog/Seating furniture/Pouf, Footstool#Round pouf": "Круглый пуфик",
 "@catalog/Seating furniture/Pouf, Footstool#Oval pouf": "Овальный пуфик",
 "@catalog/Seating furniture/Pouf, Footstool#Square pouf": "Квадратный пуфик",
 "@catalog/Seating furniture/Pouf, Footstool#Rectangle pouf": "Прямоугольный пуфик",
 "@catalog/Seating furniture/Pouf, Footstool#Abstract pouf": "Абстрактный пуфик",
 "@catalog/Seating furniture/Pouf, Footstool#Storage pouf": "Пуфик с ящиком",
 "@catalog/Seating furniture/Pouf, Footstool#Low pouf": "Низкий пуфик",
 "@catalog/Seating furniture/Pillow": "Подушка",
 "@catalog/Seating furniture/Bean Bag": "Кресло-мешок",
 "@catalog/Seating furniture/Outdoor Furniture": "Мебель для улицы",
 "@catalog/Seating furniture/Outdoor Furniture#Conversation Set": "Conversation Set",
 "@catalog/Seating furniture/Outdoor Furniture#Outdoor Sofa": "Скамья",
 "@catalog/Seating furniture/Outdoor Furniture#Outdoor Armchair": "Кресло",
 "@catalog/Seating furniture/Outdoor Furniture#Adirondack Chair": "Стул адирондак",
 "@catalog/Seating furniture/CommercialSeating": "Коммерческая мебель",
 "@catalog/Seating furniture/CommercialSeating/Cafe Seating": "Мебель кафе",
 "@catalog/Seating furniture/CommercialSeating/Waiting Room Chairs": "Стулья для зала ожидания",
 "@catalog/Seating furniture/CommercialSeating/Waiting Room Chairs#1 Chair": "1-местные",
 "@catalog/Seating furniture/CommercialSeating/Waiting Room Chairs#2 Chairs": "2-местные",
 "@catalog/Seating furniture/CommercialSeating/Waiting Room Chairs#3 Chairs": "3-местные",
 "@catalog/Seating furniture/CommercialSeating/Waiting Room Chairs#3+ Chairs": "3+ мест",
 "@catalog/Seating furniture/CommercialSeating/Beauty chairs": "Beauty chairs",
 "@catalog/Seating furniture/CommercialSeating/Tribune": "Трибуна",
 "@catalog/Seating furniture/CommercialSeating/Theater Chairs": "Театральные стулья",
 "@catalog/Seating furniture/CommercialSeating/Theater Chairs#1-seat": "1-местные",
 "@catalog/Seating furniture/CommercialSeating/Theater Chairs#2-seat": "2-местные",
 "@catalog/Seating furniture/CommercialSeating/Theater Chairs#3-seat": "3-местные",
 "@catalog/Seating furniture/CommercialSeating/Theater Chairs#3+ seats": "3+ мест",
 "@catalog/Seating furniture/Rocking chair": "Кресло-качалка",
 "@catalog/Seating furniture/Hammock": "Гамак",
 "@catalog/Seating furniture/Hammock#Hanging Hammock": "Подвесной гамак",
 "@catalog/Seating furniture/Hammock#Ceiling Hammock": "Потолочный гамак",
 "@catalog/Seating furniture/Hammock#Standing Hammock": "Напольный гамак",
 "@catalog/Seating furniture/Outdoor Bench": "Уличная скамейка",
 "@catalog/Seating furniture/Outdoor Bench#Outdoor Bench Backless": "Скамейка без спинки",
 "@catalog/Seating furniture/Outdoor Bench#Backrest Outdoor Bench": "Скамейка со спинкой",
 "@catalog/Seating furniture/Outdoor Bench#Concrete Outdoor Bench": "Бетонная скамейка",
 "@catalog/Seating furniture/Outdoor Bench#Planter Outdoor Bench": "Скамейка с цветником",
 "@catalog/Seating furniture/Outdoor Bench#Wooden Outdoor Bench": "Деревянная скамейка",
 "@catalog/Seating furniture/Outdoor Bench#Metal Outdoor Bench": "Металлическая скамейка",
 "@catalog/Seating furniture/Outdoor Bench#Upholstered Outdoor Bench": "Скамейка с обивкой",
 "@catalog/Seating furniture/Outdoor Bench#Abstract Outdoor Bench": "Абстрактная скамейка",
 "@catalog/Seating furniture/Outdoor Bench#Public Outdoor Bench": "Общественная скамейка",
 "@catalog/Seating furniture/Outdoor Bench#Garden Outdoor Bench": "Садовая скамейка",
 "@catalog/Seating furniture/Sunbed": "Шезлонг",
 "@catalog/Seating furniture/Sunbed#Single Sunbed": "Одноместный шезлонг",
 "@catalog/Seating furniture/Sunbed#Double Sunbed": "Двухместный шезлонг",
 "@catalog/Seating furniture/Sunbed#Upholstered Sunbed": "Мягкий шезлонг",
 "@catalog/Seating furniture/Sunbed#Wooden Sunbed": "Деревянный шезлонг",
 "@catalog/Seating furniture/Sunbed#Plastic Sunbed": "Пластиковый шезлонг",
 "@catalog/Seating furniture/Sunbed#Metal Sunbed": "Металлический шезлонг",
 "@catalog/Seating furniture/Sunbed#Rattan Sunbed": "Ротанговый шезлонг",
 "@catalog/Seating furniture/Sunbed#Adjustable Backrest": "Регулируемая спинка",
 "@catalog/Seating furniture/Swings": "Качели",
 "@catalog/Seating furniture/Swings#Standing Swings": "Напольные качели",
 "@catalog/Seating furniture/Swings#Swing Chair": "Кресло-качели",
 "@catalog/Seating furniture/Swings#Hanging Chair": "Подвесное кресло",
 "@catalog/Seating furniture/Swings#Hanging Swings": "Подвесные качели",
 "@catalog/kitchens": "Кухня",
 "@catalog/kitchens/Kitchen collections": "Кухонные коллекции",
 "@catalog/kitchens/Kitchen collections/Kitchen sets": "Кухонные наборы",
 "@catalog/kitchens/Kitchen collections/Kitchen sets#Base Only Kitchen": "Только низ",
 "@catalog/kitchens/Kitchen collections/Kitchen sets#Straight Kitchen": "Прямая кухня",
 "@catalog/kitchens/Kitchen collections/Kitchen sets#L-shaped kitchen": "L-shaped kitchen",
 "@catalog/kitchens/Kitchen collections/Kitchen sets#U-shaped Kitchen": "U-shaped Kitchen",
 "@catalog/kitchens/Kitchen collections/Kitchen sets#II-shaped Kitchen": "II-shaped Kitchen",
 "@catalog/kitchens/Kitchen collections/Kitchen sets#Full Wall Kitchen": "Кухня-стенка",
 "@catalog/kitchens/Kitchen collections/Base Cabinets": "Нижние шкафы",
 "@catalog/kitchens/Kitchen collections/Kitchen Island": "Кухонный остров",
 "@catalog/kitchens/Kitchen collections/Wall Cabinets": "Настенные шкафы",
 "@catalog/kitchens/Kitchen collections/Kitchen High Cabinets": "Высокие шкафы",
 "@catalog/kitchens/Kitchen collections/Countertops": "Столешницы",
 "@catalog/kitchens/Kitchen collections/Knoxhult": "Knoxhult",
 "@catalog/kitchens/Kitchen collections/Axstad": "Axstad",
 "@catalog/kitchens/Kitchen collections/Traditional kitchen": "Традиционная кухня",
 "@catalog/kitchens/Kitchen collections/Enhet": "Enhet",
 "@catalog/kitchens/Kitchen collections/Hittarp": "Hittarp",
 "@catalog/kitchens/Kitchenware": "Кухонная утварь",
 "@catalog/kitchens/Kitchenware/Kitchen decor": "Кухонный декор",
 "@catalog/kitchens/Kitchenware/Jars and boxes": "Баночки и коробки",
 "@catalog/kitchens/Kitchenware/Cups and glasses": "Чашки и стаканы",
 "@catalog/kitchens/Kitchenware/Plates": "Тарелки",
 "@catalog/kitchens/Kitchenware/Railings and wall storage": "Настенное хранение",
 "@catalog/kitchens/Kitchenware/Ingredients": "Ингредиенты",
 "@catalog/kitchens/Kitchenware/Drinks": "Напитки",
 "@catalog/kitchens/Kitchenware/Cutting boards": "Разделочные доски",
 "@catalog/kitchens/Kitchenware/Serving": "Сервировка",
 "@catalog/kitchens/Kitchenware/Desserts": "Десерты",
 "@catalog/kitchens/Kitchenware/Pans": "Посуда для готовки",
 "@catalog/AllBed": "Кровать",
 "@catalog/AllBed/Bed": "Кровать",
 "@catalog/AllBed/Bed#TwinBed": "Односпальная|кровать",
 "@catalog/AllBed/Bed#FullBed": "Full Bed",
 "@catalog/AllBed/Bed#QueenBed": "Queen Bed",
 "@catalog/AllBed/Bed#KingBed": "King Bed",
 "@catalog/AllBed/Bed#SuperKingBed": "Super King Bed",
 "@catalog/AllBed/Bed#2LevelsBed": "Двухъярусная",
 "@catalog/AllBed/Bed#LoftBed": "Loft Bed",
 "@catalog/AllBed/Bed#FourPosterBed": "Four-poster Bed",
 "@catalog/AllBed/Bed#FoldingBed": "Раскладная кровать",
 "@catalog/AllBed/Bed#CornerBed": "Угловая кровать",
 "@catalog/AllBed/Bed#RoundBed": "Круглая кровать",
 "@catalog/AllBed/Bed#OttomanBed": "Кровать с подъёмным механизмом",
 "@catalog/AllBed/Bed#StorageBed": "Кровать с ящиками",
 "@catalog/AllBed/Bed#ConvertibleBed": "Кровать-трансформер",
 "@catalog/AllBed/Bed#PlatformBed": "Кровать-платформа",
 "@catalog/AllBed/Bed#NoHeadboardBed": "Кровать без изголовья",
 "@catalog/AllBed/Bed#LeggedBed": "Кровать на ножках",
 "@catalog/AllBed/Bed#BedFrames": "Каркасы кроватей",
 "@catalog/AllBed/Bed#Daybed": "Кровать-лежак",
 "@catalog/AllBed/Bed#WallHeadboardBed": "Wall headboard bed",
 "@catalog/AllBed/Nightstand": "Прикроватная тумба",
 "@catalog/AllBed/Nightstand#Nightstand with Door": "Тумба с дверцей",
 "@catalog/AllBed/Nightstand#Nightstand with Drawers": "Тумба с ящиками",
 "@catalog/AllBed/Nightstand#1 Drawer Nightstand": "Тумба с одним ящиком",
 "@catalog/AllBed/Nightstand#Nightstand with Shelves": "Тумба с полками",
 "@catalog/AllBed/Nightstand#Round Nightstand": "Круглая тумба",
 "@catalog/AllBed/Nightstand#Corner Nightstand": "Угловая тумба",
 "@catalog/AllBed/Nightstand#No legs Nightstand": "Тумба без ножек",
 "@catalog/AllBed/Nightstand#Solid Nightstand": "Цельная тумба",
 "@catalog/AllBed/Nightstand#Wall Nightstand": "Настенная тумба",
 "@catalog/AllBed/Dressing table": "Туалетный столик",
 "@catalog/AllBed/Bedding": "Постельное белье",
 "@catalog/AllBed/Bedding#Twin bedding": "Односпальное бельё",
 "@catalog/AllBed/Bedding#Queen bedding": "Двуспальное бельё",
 "@catalog/AllBed/Bedding#King bedding": "Трехспальное бельё",
 "@catalog/AllBed/Bedding#Blankets,plaids": "Blankets,plaids",
 "@catalog/AllBed/Bedding#Mattress": "Матрас",
 "@catalog/AllBed/Bedding#Baby bedding": "Детское бельё",
 "@catalog/AllBed/KidBed": "Детская кровать",
 "@catalog/AllBed/KidBed#TwinBed": "Односпальная|кровать",
 "@catalog/AllBed/KidBed#DoubleBed": "Двуспальная кровать",
 "@catalog/AllBed/KidBed#StorageBed": "Кровать с ящиками",
 "@catalog/AllBed/KidBed#Car Bed": "Car Bed",
 "@catalog/AllBed/KidBed#2 kids Bed": "2 kids Bed",
 "@catalog/AllBed/KidBed#Multitask Bed Zone": "Multitask Bed Zone",
 "@catalog/AllBed/KidBed#House Bed": "House Bed",
 "@catalog/AllBed/Pillow": "Подушка",
 "@catalog/AllBed/Pillow#Square pillow": "Квадратная подушка",
 "@catalog/AllBed/Pillow#Round pillow": "Круглая подушка",
 "@catalog/AllBed/Pillow#Rectangle pillow": "Прямоугольная подушка",
 "@catalog/AllBed/Pillow#Abstract pillow": "Абстрактная подушка",
 "@catalog/AllBed/Pillow#Pillow set": "Набор подушек",
 "@catalog/AllBed/Pillow#Sleep pillow": "Подушка для сна",
 "@catalog/AllBed/Pillow#Roll pillow": "Подушка-валик",
 "@catalog/AllBed/Pillow#Orthopedic pillow": "Ортопедическая подушка",
 "@catalog/AllBed/Pillow#Knot pillow": "Подушка-узел",
 "@catalog/AllBed/Pillow#Seat pillow": "Подушка-сидушка",
 "@catalog/AllBed/Bed End Bench": "Скамья",
 "@catalog/AllBed/Bed End Bench#Storage Bench": "Скамья с ящиком",
 "@catalog/AllBed/Bed End Bench#Wooden Bench": "Деревянная скамья",
 "@catalog/AllBed/Bed End Bench#Upholstered Bench": "Мягкая скамья",
 "@catalog/AllBed/Bed End Bench#Oval Bench": "Овальная скамья",
 "@catalog/AllBed/Bed End Bench#Bench with Armrests": "Скамья с подлокотниками",
 "@catalog/AllBed/Bed End Bench#Bench with Back": "Скамья со спинкой",
 "@catalog/AllBed/Bed End Bench#Bench with Shelve": "Скамья с полкой",
 "@catalog/AllBed/Headboard": "Изголовье",
 "@catalog/AllBed/Headboard#Upholstered headboard": "Мягкое изголовье",
 "@catalog/AllBed/Headboard#Wooden headboard": "Деревянное изголовье",
 "@catalog/AllBed/Headboard#Rattan headboard": "Ротанговое изголовье",
 "@catalog/AllBed/Headboard#Storage headboard": "Изголовье с ящиками",
 "@catalog/AllBed/Headboard#Lighted headboard": "Изголовье со светом",
 "@catalog/AllBed/Headboard#Legged headboard": "Изголовье на ножках",
 "@catalog/AllBed/Headboard#Solid headboard": "Сплошное изголовье",
 "@catalog/AllBed/Crib": "Кроватка",
 "@catalog/AllBed/Crib#Standard crib": "Стандартная кроватка",
 "@catalog/AllBed/Crib#Convertible crib": "Кроватка-трансформер",
 "@catalog/AllBed/Crib#Rattan crib": "Ротанговая кроватка",
 "@catalog/AllBed/Crib#Mesh crib": "Сетчатая кроватка",
 "@catalog/AllBed/Crib#Cradle": "Колыбель",
 "@catalog/AllBed/Crib#Storage crib": "Кроватка с хранением",
 "@catalog/AllBed/Crib#Oval crib": "Овальная кроватка",
 "@catalog/AllBed/Crib#Crib decor": "Декор кроватки",
 "@catalog/AllBed/Bed Canopy": "Балдахин",
 "@catalog/Lighting": "Освещение",
 "@catalog/Lighting/Ceiling Lighting": "Потолочное освещение",
 "@catalog/Lighting/Ceiling Lighting#Chandelier": "Люстра",
 "@catalog/Lighting/Ceiling Lighting#Pendant Lamps": "Подвесные светильники",
 "@catalog/Lighting/Ceiling Lighting#Track Lights": "Трековые светильники",
 "@catalog/Lighting/Ceiling Lighting#Flush Mount Lights": "Светильники скрытого монтажа",
 "@catalog/Lighting/Ceiling Lighting#Semi Flush Mount Lights": "Светильники полускрытого монтажа",
 "@catalog/Lighting/Ceiling Lighting#Direct and Spot Lights": "Прямой и точечный свет",
 "@catalog/Lighting/Ceiling Lighting#Telescopic Lamps": "Телескопические лампы",
 "@catalog/Lighting/Ceiling Lighting#Kitchen Island Lighting": "Освещение кухонного острова",
 "@catalog/Lighting/Ceiling Lighting#Raindrop Lamps": "Каскадные лампы",
 "@catalog/Lighting/Ceiling Lighting#Classic Lamps": "Классические лампы",
 "@catalog/Lighting/Ceiling Lighting#LED Lighting": "LED освещение",
 "@catalog/Lighting/LightingOutletsSwitches": "Розетки, выключатели",
 "@catalog/Lighting/LightingOutletsSwitches#Switches": "Выключатели",
 "@catalog/Lighting/LightingOutletsSwitches#Outlets": "Розетки",
 "@catalog/Lighting/LightingOutletsSwitches#SwitchesOutlets": "Комбинация",
 "@catalog/Lighting/Table Lamp": "Лампа",
 "@catalog/Lighting/Table Lamp#Desk Lamp": "Настольная лампа",
 "@catalog/Lighting/Table Lamp#Bedside Lamp": "Прикроватная лампа",
 "@catalog/Lighting/Table Lamp#Arched Lamp": "Арочный торшер",
 "@catalog/Lighting/Table Lamp#Accent Lamp": "Акцентная лампа",
 "@catalog/Lighting/Table Lamp#Buffet Lamp": "Буфетная лампа",
 "@catalog/Lighting/Floor Lamp": "Торшер",
 "@catalog/Lighting/Floor Lamp#Arc Floor Lamp": "Arc Floor Lamp",
 "@catalog/Lighting/Floor Lamp#Console Floor Lamp": "Console Floor Lamp",
 "@catalog/Lighting/Floor Lamp#Torchiere Floor Lamp": "Torchiere Floor Lamp",
 "@catalog/Lighting/Floor Lamp#Multiple Floor Lamp": "Multiple Floor Lamp",
 "@catalog/Lighting/Floor Lamp#StudioLight": "StudioLight",
 "@catalog/Lighting/Wall Sconce": "Бра",
 "@catalog/Lighting/Wall Sconce#Armed Lamp": "Armed Lamp",
 "@catalog/Lighting/Wall Sconce#Swing Arm Lamp": "Swing Arm Lamp",
 "@catalog/Lighting/Wall Sconce#Flush-mount Lamp": "Flush-mount Lamp",
 "@catalog/Lighting/Wall Sconce#Candle Lamp": "Candle Lamp",
 "@catalog/Lighting/Wall Sconce#Recessed Step Lamp": "Recessed Step Lamp",
 "@catalog/Lighting/Wall Sconce#Wallchiere": "Настенный торшер",
 "@catalog/Lighting/Wall Sconce#Spotlight Lamp": "Spotlight Lamp",
 "@catalog/Lighting/Wall Sconce#Barn Lamp": "Barn Lamp",
 "@catalog/Lighting/Wall Sconce#Half Moon Lamp": "Half Moon Lamp",
 "@catalog/Lighting/Wall Sconce#Under Cabinet Light": "Under Cabinet Light",
 "@catalog/Lighting/Wall Sconce#Vanity Lamp": "Vanity Lamp",
 "@catalog/Lighting/Wall Sconce#Picture Lamp": "Picture Lamp",
 "@catalog/Lighting/Wall Sconce#Track Lamp": "Track Lamp",
 "@catalog/Lighting/Wall Sconce#Neon Lamp": "Neon Lamp",
 "@catalog/Lighting/Wall Sconce#Corner Wall Lamp": "Corner Wall Lamp",
 "@catalog/Lighting/Wall Sconce#Saber Wall Light": "Бра-меч",
 "@catalog/Lighting/Wall Sconce#Double Wall Lamp": "Двойное бра",
 "@catalog/Lighting/Wall Sconce#Multi Wall Lamp": "Бра на несколько ламп",
 "@catalog/Lighting/Wall Sconce#Accent Wall Lamp": "Акцентное бра",
 "@catalog/Lighting/Wall Sconce#Wired Wall Lamp": "Бра на проводах",
 "@catalog/Lighting/Technical Lighting": "Техническое освещение",
 "@catalog/Lighting/LED backlight": "Светодиодная подсветка",
 "@catalog/Lighting/Light Garland": "Световая гирлянда",
 "@catalog/Lighting/Ceiling fan": "Потолочный вентилятор",
 "@catalog/Lighting/Kid Lamp": "Детский светильник",
 "@catalog/Lighting/Outdoor Lighting": "Наружное освещение",
 "@catalog/Lighting/Outdoor Lighting#Roadway lights": "Уличные фонари",
 "@catalog/Lighting/Outdoor Lighting#Ground lights": "Наземные светильники",
 "@catalog/Lighting/Outdoor Lighting#Lantern": "Фонарик",
 "@catalog/HobbyAndEntertainment": "Хобби и развлечения",
 "@catalog/HobbyAndEntertainment/Sound equipment": "Музыка",
 "@catalog/HobbyAndEntertainment/Sport Equipment": "Спорт",
 "@catalog/HobbyAndEntertainment/Musical instruments": "Музыкальные инструменты",
 "@catalog/HobbyAndEntertainment/Musical instruments#Keyboard instruments": "Keyboard instruments",
 "@catalog/HobbyAndEntertainment/Musical instruments#String instruments": "String instruments",
 "@catalog/HobbyAndEntertainment/Musical instruments#Other instruments": "Другие инструменты",
 "@catalog/HobbyAndEntertainment/Movies and games": "Фильмы и игры",
 "@catalog/HobbyAndEntertainment/Movies and games#Movies": "Фильмы",
 "@catalog/HobbyAndEntertainment/Movies and games#Gaming": "Игры",
 "@catalog/HobbyAndEntertainment/More Hobby": "Больше хобби",
 "@catalog/HobbyAndEntertainment/Playground": "Детская площадка",
 "@catalog/HobbyAndEntertainment/Game table": "Игровой стол",
 "@catalog/HobbyAndEntertainment/Art equipment": "Арт-материалы",
 "@catalog/HobbyAndEntertainment/Dance": "Танцы",
 "@catalog/HobbyAndEntertainment/Events": "События",
 "@catalog/HobbyAndEntertainment/Events#Stage": "Сцена",
 "@catalog/HobbyAndEntertainment/Photo and video": "Фото и видео",
 "@catalog/HobbyAndEntertainment/Workshop equipment": "Оборудование мастерской",
 "@catalog/HobbyAndEntertainment/Grill": "Гриль",
 "@catalog/HobbyAndEntertainment/Sewing": "Шитье",
 "@catalog/HobbyAndEntertainment/Garden tools": "Садовые инструменты",
 "@catalog/Special": "Ещё",
 "@catalog/Special/Categories": "Категории",
 "@catalog/Special/Categories/Styles": "Стили",
 "@catalog/Special/Categories/Styles/Classic": "Классический",
 "@catalog/Special/Categories/Styles/Contemporary": "Современный",
 "@catalog/Special/Categories/Styles/Shabby Chic": "Шебби шик",
 "@catalog/Special/Categories/Styles/Boho": "Бохо",
 "@catalog/Special/Categories/Styles/Memphis": "Мемфис",
 "@catalog/Special/Categories/Styles/Scandinavian": "Скандинавский",
 "@catalog/Special/Categories/Styles/Coastal,Beach": "Прибрежный, Пляжный",
 "@catalog/Special/Categories/Styles/Victorian": "Викторианский",
 "@catalog/Special/Categories/Styles/Industrial": "Лофт",
 "@catalog/Special/Categories/Styles/Rustic,Farmhouse": "Рустикальный, Фермерский",
 "@catalog/Special/Categories/Styles/Transitional": "Переходный",
 "@catalog/Special/Categories/Styles/Wabi-sabi": "Ваби-саби",
 "@catalog/Special/Categories/Styles/Neoclassic": "Неоклассический",
 "@catalog/Special/Categories/Styles/Retro": "Ретро",
 "@catalog/Special/Categories/Styles/70s": "70-е",
 "@catalog/Special/Categories/Styles/Mediterranean": "Средиземноморский",
 "@catalog/Special/Categories/Styles/Oriental, Asian": "Ориентальный, азиатский",
 "@catalog/Special/Categories/Styles/Craftsman": "Ремесленный",
 "@catalog/Special/Categories/Styles/Tropical": "Тропический",
 "@catalog/Special/Categories/Styles/Mid-century Modern": "Модерн 50-х годов",
 "@catalog/Special/Categories/Styles/Eclectic": "Эклектика",
 "@catalog/Special/Categories/Styles/Southwestern": "Юго-западный",
 "@catalog/Special/Categories/Collections": "Темы",
 "@catalog/Special/Categories/Collections/Thanksgiving": "День благодарения",
 "@catalog/Special/Categories/Collections/Events": "События",
 "@catalog/Special/Categories/Collections/Events#Stage": "Сцена",
 "@catalog/Special/Categories/Collections/Wedding": "Свадьба",
 "@catalog/Special/Categories/Collections/Christmas": "Рождество",
 "@catalog/Special/Categories/Collections/Halloween": "Хеллоуин",
 "@catalog/Special/Categories/Collections/Beauty salon": "Салон красоты",
 "@catalog/Special/Categories/Collections/Barbie": "Барби",
 "@catalog/Special/Categories/Collections/Tiny house": "Мини-дом",
 "@catalog/Special/Categories/Collections/GoToSchool": "Снова в школу",
 "@catalog/Special/Categories/Collections/Cottagecore": "Коттеджкор",
 "@catalog/Special/Categories/Collections/Smart Home": "Умный дом",
 "@catalog/Special/Categories/Collections/Hospital": "Больница",
 "@catalog/Special/Categories/Collections/SummerFreshness": "Летняя свежесть",
 "@catalog/Special/Categories/Collections/Underwater": "Подводный мир",
 "@catalog/Special/Categories/Collections/Dark Academia": "Дарк академия",
 "@catalog/Special/Categories/Collections/ValentinesDay": "День святого Валентина",
 "@catalog/Special/Categories/Collections/Medieval castle": "Средневековый замок",
 "@catalog/Special/Categories/Collections/SpringBlossom": "Весеннее цветение",
 "@catalog/Special/Categories/Collections/Church": "Церковь",
 "@catalog/Special/Categories/Collections/Ghost house": "Дом с привидениями",
 "@catalog/Special/Categories/Collections/EidMubarak": "Ид Мубарак",
 "@catalog/Special/Categories/Collections/Wild West": "Дикий Запад",
 "@catalog/Special/Categories/Collections/Space Odyssey": "Космическая одиссея",
 "@catalog/Special/Categories/Collections/MardiGras": "Марди Гра",
 "@catalog/Special/Categories/Collections/WinterWonderland": "Зимняя сказка",
 "@catalog/Special/Categories/Collections/Pirates": "Пираты",
 "@catalog/Special/Categories/Collections/StPatricksDay": "День святого Патрика",
 "@catalog/Special/Categories/Brands": "Бренды",
 "@catalog/Special/Categories/Brands/IKEA": "ИКЕА",
 "@catalog/Special/Categories/Brands/IKEA/Knoxhult": "Knoxhult",
 "@catalog/Special/Categories/Brands/IKEA/Enhet": "Enhet",
 "@catalog/Special/Categories/Brands/IKEA/Sektion": "Сектион",
 "@catalog/Special/Categories/Brands/IKEA/All IKEA": "Вся ИКЕА",
 "@catalog/Special/Categories/Brands/IKEA/Hemnes": "Хемнэс",
 "@catalog/Special/Categories/Brands/IKEA/Pax": "Пакс",
 "@catalog/Special/Categories/Brands/IKEA/Billy": "Билли",
 "@catalog/Special/Categories/Brands/IKEA/Malm": "Мальм",
 "@catalog/Special/Categories/Brands/IKEA/Kallax": "Каллакс",
 "@catalog/Special/Categories/Brands/IKEA/Grönlid": "Grönlid",
 "@catalog/Special/Categories/Brands/IKEA/Platsa": "Platsa",
 "@catalog/Special/Categories/Brands/IKEA/Alex / Linnmon": "Alex / Linnmon",
 "@catalog/Special/Categories/Brands/IKEA/Brimnes": "Бримнэс",
 "@catalog/Special/Categories/Brands/IKEA/Eket": "Eket",
 "@catalog/Special/Categories/Brands/IKEA/Besta": "Бесто",
 "@catalog/Special/Categories/Brands/IKEA/Ektorp": "Экторп",
 "@catalog/Special/Categories/Brands/IKEA/Lidhult": "Lidhult",
 "@catalog/Special/Categories/Brands/IKEA/Mandal": "Мандал",
 "@catalog/Special/Categories/Brands/IKEA/Tyssedal": "Tyssedal",
 "@catalog/Special/Categories/Brands/IKEA/Vimle": "Vimle",
 "@catalog/Special/Categories/Brands/IKEA/Liatorp": "Лиаторп",
 "@catalog/Special/Categories/Brands/IKEA/Kleppstad": "Kleppstad",
 "@catalog/Special/Categories/Brands/IKEA/Bjorksta": "Bjorksta",
 "@catalog/Special/Categories/Brands/IKEA/Lommarp": "Lommarp",
 "@catalog/Special/Categories/Brands/IKEA/Lagan": "Lagan",
 "@catalog/Special/Categories/Brands/IKEA/Havsta": "Havsta",
 "@catalog/Special/Categories/Brands/IKEA/Karlstad": "Карлстад",
 "@catalog/Special/Categories/Brands/IKEA/Sundvik": "Sundvik",
 "@catalog/Special/Categories/Brands/IKEA/Backsälen": "Backsälen",
 "@catalog/Special/Categories/Brands/IKEA/Bekant": "Bekant",
 "@catalog/Special/Categories/Brands/IKEA/Gursken": "Gursken",
 "@catalog/Special/Categories/Brands/IKEA/Elvarli": "Elvarli",
 "@catalog/Special/Categories/Brands/IKEA/Bjursta": "Бьюрста",
 "@catalog/Special/Categories/Brands/IKEA/Kivik": "Кивик",
 "@catalog/Special/Categories/Brands/IKEA/Rågrund": "Rågrund",
 "@catalog/Special/Categories/Brands/IKEA/Songesand": "Songesand",
 "@catalog/Special/Categories/Brands/IKEA/Finnala": "Finnala",
 "@catalog/Special/Categories/Brands/IKEA/Friheten": "Friheten",
 "@catalog/Special/Categories/Brands/IKEA/Lack": "Лакк",
 "@catalog/Special/Categories/Brands/IKEA/Lycksele": "Lycksele",
 "@catalog/Special/Categories/Brands/IKEA/Ekedalen": "Ekedalen",
 "@catalog/Special/Categories/Brands/IKEA/Nordli": "Нордли",
 "@catalog/Special/Categories/Brands/IKEA/Micke": "Micke",
 "@catalog/Special/Categories/Brands/IKEA/Tullsta": "Тульста",
 "@catalog/Special/Categories/Brands/IKEA/Satsumas": "Satsumas",
 "@catalog/Special/Categories/Brands/IKEA/Stockholm": "Стокгольм",
 "@catalog/Special/Categories/Brands/IKEA/Äpplaryd": "Äpplaryd",
 "@catalog/Special/Categories/Brands/IKEA/Färlöv": "Färlöv",
 "@catalog/Special/Categories/Brands/IKEA/Isala": "Исала",
 "@catalog/Special/Categories/Brands/IKEA/Nikkeby": "Nikkeby",
 "@catalog/Special/Categories/Brands/IKEA/Släkt": "Släkt",
 "@catalog/Special/Categories/Brands/IKEA/Vihals": "Vihals",
 "@catalog/Special/Categories/Brands/IKEA/Pjatteryd": "Pjatteryd",
 "@catalog/Special/Categories/Brands/IKEA/Arkelstorp": "Arkelstorp",
 "@catalog/Special/Categories/Brands/IKEA/Smastad": "Smastad",
 "@catalog/Special/Categories/Brands/IKEA/Odda": "Одда",
 "@catalog/Special/Categories/Brands/IKEA/Hauga": "Hauga",
 "@catalog/Special/Categories/Brands/IKEA/Härlanda": "Härlanda",
 "@catalog/Special/Categories/Brands/IKEA/Regissör": "Regissör",
 "@catalog/Special/Categories/Brands/IKEA/Holmsund": "Holmsund",
 "@catalog/Special/Categories/Brands/IKEA/Nordviken": "Nordviken",
 "@catalog/Special/Categories/Brands/IKEA/Trofast": "Trofast",
 "@catalog/Special/Categories/Brands/IKEA/Fjällbo": "Fjällbo",
 "@catalog/Special/Categories/Brands/IKEA/Idanäs": "Idanäs",
 "@catalog/Special/Categories/Brands/IKEA/Långfjäll": "Långfjäll",
 "@catalog/Special/Categories/Brands/IKEA/Simrishamn": "Simrishamn",
 "@catalog/Special/Categories/Brands/IKEA/Tornviken": "Tornviken",
 "@catalog/Special/Categories/Brands/IKEA/Vadholma": "Vadholma",
 "@catalog/Special/Categories/Brands/IKEA/Vallentuna": "Vallentuna",
 "@catalog/Special/Categories/Brands/IKEA/Trotten": "Trotten",
 "@catalog/Special/Categories/Brands/IKEA/Valje": "Вэлье",
 "@catalog/Special/Categories/Brands/IKEA/Nymåne": "Nymåne",
 "@catalog/Special/Categories/Brands/IKEA/Varde": "Вёрда",
 "@catalog/Special/Categories/Brands/IKEA/Baggebo": "Baggebo",
 "@catalog/Special/Categories/Brands/IKEA/Busunge": "Busunge",
 "@catalog/Special/Categories/Brands/IKEA/Lixhult": "Lixhult",
 "@catalog/Special/Categories/Brands/IKEA/Godmorgon": "Godmorgon",
 "@catalog/Special/Categories/Brands/IKEA/Ivar": "Ivar",
 "@catalog/Special/Categories/Brands/IKEA/Stuva": "Stuva",
 "@catalog/Special/Categories/Brands/IKEA/Mammut": "Mammut",
 "@catalog/Special/Categories/Brands/IKEA/Pinnig": "Pinnig",
 "@catalog/Special/Categories/Brands/IKEA/Vinliden": "Vinliden",
 "@catalog/Special/Categories/Brands/IKEA/Morabo": "Morabo",
 "@catalog/Special/Categories/Brands/IKEA/Stocksund": "Stocksund",
 "@catalog/Special/Categories/Brands/IKEA/Norden": "Норден",
 "@catalog/Special/Categories/Brands/IKEA/Nävlinge": "Nävlinge",
 "@catalog/Special/Categories/Brands/IKEA/Pärup": "Pärup",
 "@catalog/Special/Categories/Brands/IKEA/Sniglar": "Sniglar",
 "@catalog/Special/Categories/Brands/IKEA/Stenstorp": "Stenstorp",
 "@catalog/Special/Categories/Brands/IKEA/Söderhamn": "Söderhamn",
 "@catalog/Special/Categories/Brands/IKEA/Torparö": "Torparö",
 "@catalog/Special/Categories/Brands/IKEA/Klippan": "Клиппан",
 "@catalog/Special/Categories/Brands/IKEA/Råvaror": "Råvaror",
 "@catalog/Special/Categories/Brands/IKEA/Mackapär": "Mackapär",
 "@catalog/Special/Categories/Brands/IKEA/Strandmon": "Strandmon",
 "@catalog/Special/Categories/Brands/IKEA/Ranarp": "Ranarp",
 "@catalog/Special/Categories/Brands/IKEA/Skurup": "Skurup",
 "@catalog/Special/Categories/Brands/IKEA/Sollerön": "Sollerön",
 "@catalog/Special/Categories/Brands/IKEA/Kvart": "Кварт",
 "@catalog/Special/Categories/Brands/IKEA/Rönnskär": "Rönnskär",
 "@catalog/Special/Categories/Brands/IKEA/Sandsberg": "Sandsberg",
 "@catalog/Special/Categories/Brands/IKEA/Ingatorp": "Ingatorp",
 "@catalog/Special/Categories/Brands/IKEA/Nordkisa": "Nordkisa",
 "@catalog/Special/Categories/Brands/IKEA/Nyhamn": "Nyhamn",
 "@catalog/Special/Categories/Brands/IKEA/Bondholmen": "Bondholmen",
 "@catalog/Special/Categories/Brands/IKEA/Vittsjö": "Vittsjö",
 "@catalog/Special/Categories/Brands/IKEA/Hektar": "Hektar",
 "@catalog/Special/Categories/Brands/IKEA/Ingolf": "Ингольф",
 "@catalog/Special/Categories/Brands/IKEA/Askholmen": "Askholmen",
 "@catalog/Special/Categories/Brands/IKEA/Galant": "Galant",
 "@catalog/Special/Categories/Brands/IKEA/Havsten": "Havsten",
 "@catalog/Special/Categories/Brands/IKEA/Koarp": "Koarp",
 "@catalog/Special/Categories/Brands/IKEA/Lisabo": "Lisabo",
 "@catalog/Special/Categories/Brands/IKEA/Lantliv": "Lantliv",
 "@catalog/Special/Categories/Brands/IKEA/Flottebo": "Flottebo",
 "@catalog/Special/Categories/Brands/IKEA/Rönninge": "Rönninge",
 "@catalog/Special/Categories/Brands/IKEA/Äpplarö": "Äpplarö",
 "@catalog/Special/Categories/Brands/IKEA/Uppspel": "Uppspel",
 "@catalog/Special/Categories/Brands/IKEA/Själland": "Själland",
 "@catalog/Special/Categories/Brands/IKEA/Tjusig": "Tjusig",
 "@catalog/Special/Categories/Brands/IKEA/Läckö": "Läckö",
 "@catalog/Special/Categories/Brands/IKEA/Bergmund": "Bergmund",
 "@catalog/Special/Categories/Brands/IKEA/Jutholmen": "Jutholmen",
 "@catalog/Special/Categories/Sandbox": "Архив",
 "@catalog/Special/Annotations": "Аннотации",
 "@material/Bricks": "Кирпич",
 "@material/Metal": "Металл",
 "@material/Tile": "Плитка",
 "@material/Marble": "Мрамор",
 "@material/Granite": "Гранит",
 "@material/Stone": "Камень",
 "@material/MaterialPlants": "Растения",
 "@material/Ground": "Грунт",
 "@material/Roof": "Кровля",
 "@material/Carpet": "Ковры",
 "@material/Parquet or Laminate": "Паркет и ламинат",
 "@material/Wallpapers": "Обои",
 "@material/Paneling": "Панели",
 "@material/Slats": "Рейки",
 "@material/Wood": "Дерево",
 "@material/Finishes": "Отделка",
 "@material/Leather": "Кожа",
 "@material/Rattan": "Ротанг",
 "@material/Fabric": "Ткани",
 "@material/Photo Wallpaper": "Фотообои",
 "@material/Water": "Вода",
 "@material/Neon": "Неон",
 "@material/Glass": "Стекло",
 "@material/Sky": "Небо",
 "@material/Other": "Другое"
}
